var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327.242,
    height: 244.76,
    viewBox: "0 0 327.242 244.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3247",
    "data-name": "Group 3247",
    transform: "translate(-163.08 -4144.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(163.08 4199.234)",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M202.467,168.4s-1.632,38.633-8.818,37.886,4.928-42.919,4.928-42.919S167.952,138.827,154.119,137c0,0,12.972,41.1,6.193,38.612s-22.271-44.632-22.271-44.632-33.831-14.724-44.369,4.864-3.806,32.163,1.127,34.683,38.64,9.871,36.754,14.024-26.2,5.861-37.948-.991c0,0,5.959,37.639,24.7,40.146s27.044-7.5,38.592-5.744,19.134,6.728,12.75,8.462-25.109-4.766-36.083.885-19.508,8.723-3.3,16.15,47.266,12.331,56.417.681l1.145-1.457a7.074,7.074,0,0,1-1.145,1.457c2.714,2.557,5.4,12.363,7.106,19.807.2,1.246.572,2.992,1.169,5.383h0c.219,1.07.389,1.942.506,2.552,2.514,16.368-6.686,41.5-6.686,41.5l3.409,1.818c14.126-24.2,4.975-48.894,4.975-48.894-5.211-19.107-1.329-33.812-1.329-33.812s36.988-10.706,27.491-39.067C223.321,193.423,214.647,175.35,202.467,168.4Z",
    transform: "translate(-88.092 -125.668)",
    fill: "#dfeafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M408.016,157.16c-1.04-21.814-37.2-23.032-37.2-23.032s-31.523,30.83-38.574,30.178,21.805-31.624,21.805-31.624c-13.013-4.215-50.485,4.621-50.485,4.621s-7.113,42.5-13.786,40.133S298,140.124,298,140.124c-13.717,1.025-29.033,13.392-29.033,13.392-20.4,21.141,7.8,46.238,7.8,46.238s-2.783,14.677-15.473,29.42h0a50.863,50.863,0,0,0-5.935,7.434l3.508.774q.741-1.318,1.551-2.514l.011-.015.024-.033c.359-.49.874-1.185,1.511-2.03l0,0,0,0c1.534-1.863,2.6-3.253,3.3-4.271l.006-.009c4.662-5.879,11.178-13.44,14.66-14.56a7,7,0,0,1-.4-1.775c.126.566.259,1.156.4,1.775,3.17,14.189,32.72,22.946,50.2,23.2s11.231-6.07,3.911-15.711-26.636-11.778-31.551-16.009,3.9-5.438,14.858-2.124,14.082,15.692,31.718,21.376S387.9,199.5,387.9,199.5c-13.288,1.121-34.078-10.653-33.991-15.131s33.016,3.224,38.446,3.072S409.057,178.975,408.016,157.16Z",
    transform: "translate(-80.841 -122.61)",
    fill: "#b2cbfd",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982",
    transform: "translate(219.656 4144.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "matrix(0.208, 0.978, -0.978, 0.208, 109.457, 99.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M2.759,9.393C5.056,8.954,0,3.333,0,3.333S2.7,2.41,6.19,1.539C7.052,1.324,14.174-.3,17.16.05c11.57,1.373,21.8,39.9,10.835,48.28a33.611,33.611,0,0,1-8.3,3.846A40.115,40.115,0,0,1,8.965,54.136C2.767,20.54,1.634,9.608,2.759,9.393Z",
    transform: "translate(84.498 0)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 11.648,
    cy: 25.791,
    rx: 11.648,
    ry: 25.791,
    transform: "matrix(0.982, -0.188, 0.188, 0.982, 73.057, 5.521)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M0,11.058C1.491,10.491,48.769-4.9,58.332,1.595c.649.441,4.135,6.362,2.816,12.262,0,0-13.246,9.969-54.389,12.85Z",
    transform: "translate(32.007 18.743)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M2.759,9.393C5.056,8.954,0,3.333,0,3.333S2.7,2.41,6.19,1.539C7.052,1.324,14.174-.3,17.16.05,28.73,1.424,38.963,39.947,28,48.331a33.623,33.623,0,0,1-8.3,3.846A40.13,40.13,0,0,1,8.965,54.136C2.767,20.54,1.635,9.608,2.759,9.393Z",
    transform: "translate(11.44 14.402)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 11.648,
    cy: 25.791,
    rx: 11.648,
    ry: 25.791,
    transform: "translate(0 19.923) rotate(-10.829)",
    fill: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(58.137 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M249.8,43.637s-9.369,2.9-7.149,12.032c0,0,14.537.713,17.006-2.7S249.8,43.637,249.8,43.637Z",
    transform: "translate(-200.2 -38.313)",
    fill: "#382926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M295.1,53.038s3.668,1.69,4.539-1.564S294.837,51.035,295.1,53.038Z",
    transform: "translate(-221.895 -40.924)",
    fill: "#e29f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M201.071,51.75s2.483,3.185,4.75.694S201.753,49.849,201.071,51.75Z",
    transform: "translate(-183.252 -41.108)",
    fill: "#e29f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M262.555,90.529c-.558,3.079.133,6.235.947,9.258s1.759,6.062,1.715,9.189-1.281,6.436-3.931,8.093a.636.636,0,0,1-.076.044c-.867.02-1.742-.012-2.6-.048-1.533-.064-3.284-.24-4.179-1.489a4.89,4.89,0,0,1-.694-2.232,45.448,45.448,0,0,1,1.494-18.659c.755-2.541,1.73-5.022,2.324-7.607,1.035-4.553.847-9.285.5-13.938a35.74,35.74,0,0,0-1.445-8.776c-.642-1.923-1.577-3.733-2.24-5.648-1.265-3.665-2.762-11.461,1.413-13.765l.137-.072a12.25,12.25,0,0,1,8.462,3.3c3.328,3.272,4.412,8.165,4.929,12.8.727,6.483.6,13.276-2.1,19.217C265.654,83.653,263.234,86.8,262.555,90.529Z",
    transform: "translate(-204.611 -38.823)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 4.165,
    cy: 2.986,
    rx: 4.165,
    ry: 2.986,
    transform: "translate(51.612 4.614)",
    fill: "#ec5254"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(25.55 192.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M240.618,370.108a2.928,2.928,0,0,1-.217,1.369c-.9,2.244-4.252,4.05-6.182,4.307a7.438,7.438,0,0,0-2.373.775,9.433,9.433,0,0,0-1.8,1.18c-5.468,3.886-12.12,4.142-14.913.124-1.277-1.842-1.06-3.235-.446-4.2a5,5,0,0,1,2-1.694l2.894-1.726.341-.209,1.518-.9.341-.2,1.4-.839.345-.2,8.944-5.344a4.161,4.161,0,0,0,.273,4.766c1.827,2.593,5.255-.651,6.231-1.22a2.021,2.021,0,0,1,1.738-.233,3.993,3.993,0,0,0-.084.494A17.111,17.111,0,0,0,240.618,370.108Z",
    transform: "translate(-214.196 -357.81)",
    fill: "#df5153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M236.09,362.942l1.749-7.933a.735.735,0,0,1,.916-.475l4.067.9a.736.736,0,0,1,.631.817l-1.75,7.933Z",
    transform: "translate(-223.194 -354.511)",
    fill: "#df5153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M246.575,358.21l-2.653,8.425,1.2.1Z",
    transform: "translate(-226.413 -356.031)",
    fill: "#b83c42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M234.218,382.025a8.957,8.957,0,0,0-4.173,1.956c-5.467,3.887-12.12,4.143-14.912.124-1.28-1.844-1.06-3.236-.448-4.2a19.3,19.3,0,0,0,.261,2.456,4.663,4.663,0,0,0,2.151,2.614,6.761,6.761,0,0,0,3.681.878,15.055,15.055,0,0,0,6.258-2.128,51.394,51.394,0,0,1,6.122-3.036c2.455-.918,5.178-1.375,7.245-2.969C239.507,379.96,236.153,381.765,234.218,382.025Z",
    transform: "translate(-214.197 -364.048)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(5.382 12.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M225.9,379.324a.2.2,0,0,1-.184.2.2.2,0,0,1-.153-.068.172.172,0,0,1-.044-.116c-.04-1.434-1.2-2.891-2.184-3.866l.341-.208C224.691,376.286,225.859,377.787,225.9,379.324Z",
    transform: "translate(-223.334 -375.262)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(7.241 11.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M229.107,377.492a.191.191,0,0,1-.337.128.176.176,0,0,1-.044-.117c-.04-1.461-1.24-2.939-2.236-3.918l.341-.2C227.855,374.4,229.063,375.93,229.107,377.492Z",
    transform: "translate(-226.49 -373.381)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "translate(8.984 10.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M232.037,375.691a.191.191,0,0,1-.184.193.178.178,0,0,1-.153-.068.173.173,0,0,1-.044-.116c-.04-1.445-1.22-2.911-2.208-3.886l.345-.2C230.809,372.629,232,374.142,232.037,375.691Z",
    transform: "translate(-229.448 -371.609)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M246.452,378.439a7.466,7.466,0,0,0-2.371.774,2.62,2.62,0,0,1,.425-2.307,7.666,7.666,0,0,1,1.839-1.7q1.276-.937,2.546-1.881a12.493,12.493,0,0,0,3.212-3.486,3.552,3.552,0,0,1,.76-.842,17,17,0,0,0-.011,3.767,2.91,2.91,0,0,1-.215,1.368C251.74,376.375,248.385,378.181,246.452,378.439Z",
    transform: "translate(-226.43 -360.464)",
    fill: "#153965"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M230.427,187.006s-2.006,34.877,4.664,53.841c0,0,6.67,40.674,5.755,45.252,0,0,.915,3.27,5.1.785,0,0,8.37-27.072,0-38.451,0,0-.654-21.318,1.046-26.549s4.883-41.852,4.883-41.852Z",
    transform: "translate(-195.201 -90.15)",
    fill: "#f99e5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M250.077,185.215s-12.142,34.71-11.619,55.461,4.708,50.4,4.534,56.674c0,0,6.8,2.616,8.545-4.883,0,0-1.918-10.114,0-16.915s1.7-19.356-2.834-29.471c0,0,13.535-38.648,13.188-49.448-.178-5.554-5.142-16.207-6.605-16.729C251.492,178.551,250.077,185.215,250.077,185.215Z",
    transform: "translate(-198.611 -90.024)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M245.686,99.286s-9.591-.711-14.3,6.044-6.888,10.576-7.149,13.332,1.133,5.155,2.529,7.11,1.569,23.553,1.22,29.063c0,0,9.757,7.7,21.449-7.11,0,0-3.052-7.732-.436-13.6S275.592,97.153,245.686,99.286Z",
    transform: "translate(-192.76 -60.174)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(56.675 6.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M267.428,88.232s3.27-9.155,15.956-7.717c0,0,6.931-6.147,15.433-5.231,0,0-5.842-10.921-5.711-14.191s-3.456-6.724-3.456-6.724l3.935-2.235s13.6,18.31,15.04,21.187,1.047,5.493-3.531,8.109-15.956,9.155-20.534,9.94-8.5,3.008-9.94,4.708S265.2,94.51,267.428,88.232Z",
    transform: "translate(-267.039 -47.854)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M304.01,50.218s-1.883-3.184-4.248-3.866c-1.934-.557-5.313-1.389-5.313-1.389a1.675,1.675,0,0,0-2.093.872c-.7,1.4-1.831,3.836-1.831,3.836a1.305,1.305,0,0,0,.785,1.57,2.036,2.036,0,0,0,1.395.654,2.228,2.228,0,0,0,1.875.7h2.441a.492.492,0,0,0,.567-.523c.044-.61-.48-.828-.959-.828s-2.136-.262-2.136-.262.479-2.049,1.613-1.613a10.682,10.682,0,0,1,4.517,3.554Z",
    transform: "translate(-276.671 -44.867)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(0 5.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M213.8,85.829s-4.181-8.776-16.656-6.058c0,0-7.519-5.412-15.884-3.638,0,0,4.7-11.457,4.242-14.7s2.756-7.04,2.756-7.04l-4.142-1.824s-11.674,19.6-12.813,22.6-.484,5.57,4.336,7.708,16.8,7.489,21.436,7.805,8.762,2.13,10.366,3.675S216.649,91.849,213.8,85.829Z",
    transform: "translate(-170.819 -47.352)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M192.239,50.075s1.55-3.359,3.834-4.277c1.868-.75,5.144-1.921,5.144-1.921a1.674,1.674,0,0,1,2.17.655c.836,1.317,2.211,3.631,2.211,3.631a1.305,1.305,0,0,1-.621,1.641,2.038,2.038,0,0,1-1.322.792,2.228,2.228,0,0,1-1.794.884l-2.429.248a.493.493,0,0,1-.617-.464c-.105-.6.393-.872.87-.921s2.1-.477,2.1-.477-.685-1.99-1.768-1.441a10.685,10.685,0,0,0-4.133,3.993Z",
    transform: "translate(-179.622 -43.71)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M258.474,195.752a51.915,51.915,0,0,1-2.579,15.158.1.1,0,0,0-.005.023c-.137-.16-.279-.307-.421-.455-6.489-6.757-15.3-.319-16.382.512-.023.017-.04.034-.057.046-.034.028-.051.039-.051.039-2.857-1.593-8.749,1.361-8.749,1.361-1.041-4.684-.37-18.875-.1-23.821.063-1.087.1-1.731.1-1.731,2.453,2.009,21.385-7.144,21.385-7.144.467.444.666.672,1.036,1.036.062.062.131.125.2.2.273.222.529.455.78.694.1.085.193.182.284.279.12.125.245.256.359.387.137.148.267.3.393.455C257.569,186.315,258.474,191.113,258.474,195.752Z",
    transform: "translate(-195.005 -92.348)",
    fill: "#194276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M254.933,123.426c-1.856,3.284-3.74,6.21-4.929,8.208-.313.524-.575.985-.774,1.372a82.336,82.336,0,0,1-21.368.8c-.023-.558-.051-1.1-.091-1.633-.125-2.106-.3-3.916-.507-5.174a5,5,0,0,0-.5-1.736c-1.389-1.918-2.79-4.269-2.522-6.973s2.436-6.454,7.149-13.074a13.15,13.15,0,0,1,6-4.565,20.849,20.849,0,0,1,8.293-1.366,25.661,25.661,0,0,1,8.806.62,10.607,10.607,0,0,1,2.5,1.058C263.869,105.047,259.5,115.338,254.933,123.426Z",
    transform: "translate(-192.761 -60.285)",
    fill: "#ec5254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M252.491,154.277c-.313.522-.574.984-.775,1.369a82.276,82.276,0,0,1-21.365.807c-.028-.562-.056-1.108-.092-1.633C233.639,154.9,246.108,155.132,252.491,154.277Z",
    transform: "translate(-195.248 -82.432)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M260.924,99.9c-7.041,14.006-14.054,15.235-16.615,15.118-2.879-.133-4.316-1.963-4.448-4.97-.061-1.4,1.883-5.471,3.966-9.4a20.871,20.871,0,0,1,8.294-1.365A25.755,25.755,0,0,1,260.924,99.9Z",
    transform: "translate(-199.194 -60.365)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M273.722,124.672a5.463,5.463,0,0,1-2.81-1.943,7.274,7.274,0,0,1-.943-4.809c.217-2.774,2.364-11.437,5.821-15.713C282.658,106.29,278.295,116.579,273.722,124.672Z",
    transform: "translate(-211.55 -61.544)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(40.915 197.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M255.365,374.989a7.875,7.875,0,0,0-.968,2.449,9.952,9.952,0,0,0-.253,2.26c-.522,7.062-4.793,12.641-9.94,12.2-2.361-.2-3.344-1.316-3.717-2.464a5.273,5.273,0,0,1-.032-2.766l2.967-19.181a4.387,4.387,0,0,0,4.055,2.986c3.336.261,3.006-4.709,3.2-5.885a2.13,2.13,0,0,1,.98-1.57,4.38,4.38,0,0,0,.345.4,17.947,17.947,0,0,0,3.055,2.545,3.074,3.074,0,0,1,.968,1.1C257.248,369.3,256.457,373.243,255.365,374.989Z",
    transform: "translate(-240.283 -363.022)",
    fill: "#f05759"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M243.873,375.4v-8.575a.777.777,0,0,1,.836-.7h4.4a.777.777,0,0,1,.836.7V375.4Z",
    transform: "translate(-241.758 -364.299)",
    fill: "#f05759"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M253.6,368.128l-.82,9.287,1.254-.174Z",
    transform: "translate(-245.421 -365.12)",
    fill: "#c94148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M255.51,377.807a9.459,9.459,0,0,0-1.22,4.709c-.522,7.062-4.793,12.641-9.94,12.2-2.36-.2-3.344-1.316-3.717-2.464A20.344,20.344,0,0,0,242.8,393.7a4.921,4.921,0,0,0,3.573.012,7.132,7.132,0,0,0,3.191-2.4,15.9,15.9,0,0,0,2.485-6.519,54.18,54.18,0,0,1,1.654-7.021c.907-2.613,2.368-5.134,2.465-7.889C257.393,372.118,256.6,376.06,255.51,377.807Z",
    transform: "translate(-240.427 -365.84)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(0.491 19.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M247.989,397.843a.2.2,0,0,1-.124-.043c-2.066-1.62-6.454-.534-6.5-.522a.2.2,0,1,1-.1-.389c.188-.048,4.624-1.146,6.845.595a.2.2,0,0,1,.034.282A.2.2,0,0,1,247.989,397.843Z",
    transform: "translate(-241.117 -396.504)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(0.918 17.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M248.713,393.994a.2.2,0,0,1-.124-.043c-2.066-1.62-6.454-.534-6.5-.522a.2.2,0,0,1-.1-.389c.188-.048,4.624-1.146,6.845.6a.2.2,0,0,1-.124.359Z",
    transform: "translate(-241.841 -392.655)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(1.198 15.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M249.189,390.4a.2.2,0,0,1-.124-.043c-2.066-1.62-6.454-.533-6.5-.522a.2.2,0,0,1-.1-.389c.188-.048,4.624-1.146,6.845.595a.2.2,0,0,1-.124.359Z",
    transform: "translate(-242.316 -389.063)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M263.543,375.266a7.877,7.877,0,0,0-.968,2.449,2.768,2.768,0,0,1-1.59-1.9,8.1,8.1,0,0,1-.144-2.642q.1-1.668.185-3.336a13.2,13.2,0,0,0-.671-4.958,3.744,3.744,0,0,1-.173-1.184,17.948,17.948,0,0,0,3.055,2.545,3.073,3.073,0,0,1,.968,1.1C265.426,369.578,264.635,373.52,263.543,375.266Z",
    transform: "translate(-248.461 -363.299)",
    fill: "#194276"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(41.729 4.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M252.528,84.06s2.093,3.923-3.4,7.651c0,0,2.747,7.651,10.659,3.531l2.943-4.982V76.671Z",
    transform: "translate(-244.732 -56.875)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M255.259,89.4s5.958-.364,9.991-3.852V81.874L255.259,86.7A17.463,17.463,0,0,1,255.259,89.4Z",
    transform: "translate(-247.252 -59.014)",
    fill: "#eb985f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M261.956,58.27c-.53,8.037-9.448,13.045-14.418,13.045-3.783-1.781-6.165-9.627-5.464-13.045.057-.888.609-3.039.768-3.876,1.264-6.739,5.573-11.634,10.354-11.316.1.005.2.017.307.028a6.5,6.5,0,0,1,1.281.279l.171.051C259.394,44.984,262.428,51.137,261.956,58.27Z",
    transform: "translate(-241.952 -43.063)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M252.975,180.778c-17.973,11.429-22.526,7.834-22.526,7.834.064-1.084.1-1.726.1-1.726,2.449,2.007,21.381-7.146,21.381-7.146A10.373,10.373,0,0,1,252.975,180.778Z",
    transform: "translate(-195.326 -92.556)",
    fill: "#ec5254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M230.627,233.97s5.662-2.945,8.748-1.357l-.164.7s-1.584-1.646-8.469,1.393Z",
    transform: "translate(-195.399 -113.553)",
    fill: "#ea9b86",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M251.016,49.4s9.206,6.888,14.54,6.916c0,0-.209-13.428-8.644-13.618S251.016,49.4,251.016,49.4Z",
    transform: "translate(-204.272 -35.095)",
    fill: "#2c3a64",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M275.961,64.654a1.688,1.688,0,1,1-1.687-1.688A1.688,1.688,0,0,1,275.961,64.654Z",
    transform: "translate(-212.644 -46.257)",
    fill: "#fab8a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M230.175,194.8s3.357,20.121,7.058,22c0,0-2.56-.322-6.953,1.82C230.279,218.623,228.974,210.859,230.175,194.8Z",
    transform: "translate(-195.005 -98.435)",
    fill: "#16406d",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M264.971,196.475a51.917,51.917,0,0,1-2.579,15.158.1.1,0,0,0-.005.023c-.137-.16-.279-.307-.421-.455-6.489-6.757-15.3-.319-16.382.512-.023.017-.04.034-.057.046-.034.028-.051.039-.051.039.416-20.8,5.088-25.415,5.088-25.415,1.594-.751,8.35-4.741,8.584-4.883h.006a12.335,12.335,0,0,1,.979.894c.1.085.193.182.284.279.12.125.245.256.359.387.137.148.267.3.393.455C264.066,187.037,264.971,191.836,264.971,196.475Z",
    transform: "translate(-201.502 -93.072)",
    fill: "#204f82",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M239.958,211s1.74,11.332,3.252,12.922l.07-2.441Z",
    transform: "translate(-199.234 -105.006)",
    fill: "#16406d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M245.364,230.373s9.845-8.188,16.909-.144l-.148.554s-5.919-7.562-16.925.287Z",
    transform: "translate(-201.389 -111.356)",
    fill: "#ea9b86",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M230.415,157.408a81.207,81.207,0,0,0,21.365-.807s-.256.493-.381.813a99.655,99.655,0,0,1-20.984.914Z",
    transform: "translate(-195.312 -83.365)",
    fill: "#ea9b86",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M241.726,146.412s1.517,4.166,3.5,5.253l5.93-.148A12.494,12.494,0,0,1,241.726,146.412Z",
    transform: "translate(-199.961 -79.273)",
    fill: "#d84850",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M235.925,151.664l-6.022-.08c-.125-2.106-.3-3.916-.507-5.174A5.868,5.868,0,0,0,235.925,151.664Z",
    transform: "translate(-194.893 -79.272)",
    fill: "#d84850",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M12.284.374C8.687,7.25,3.29,11.182,0,12.371.18,4.256,5.744-.3,10.525.016c.1.005.2.017.307.028.6.1,1.053.216,1.281.279Z",
    transform: "matrix(0.839, 0.545, -0.545, 0.839, 48.334, 0)",
    fill: "#382926"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M716.622,958.247s2.486-3.127,10.677,1.253c7.01,3.823,9.909,11.348,9.909,11.348s5.464,13.45-.841,19.334c-1.828,7.681-14.539,12.834-13.113,19.325,0,0-9.534-13.7,0-20.29,4.321-2.987,5.7-3.073,4.044-10.816S716.622,958.247,716.622,958.247Z",
    transform: "translate(-610.18 -953.824)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M795.746,968.134c-.12-.483,10.492,4.8,11.03,5.393,4.977,5.521,3.558,12.725.71,12.794-1.827.044,3.238,18.993-1.472,3.081-3.457-11.679-10.063-11.243-14.841-10.739-1.365.148-3.089,2.815-3.772,1.4C784.834,974.748,788.116,966.509,795.746,968.134Z",
    transform: "translate(-686.799 -964.825)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M.069,7.265C.544,4.42,1.989,4.149,3,4.339A8.3,8.3,0,0,1,13.089.475a14.127,14.127,0,0,0,8.178,4.912s-1.2,2.24-6.165,3.627a8.48,8.48,0,0,1-4.894-.391,27.7,27.7,0,0,0,7.041,2.654c-6.538.6-12.758-5.379-13.4-6.018a9.3,9.3,0,0,0-.514,4.283c.43,1.927.352,3.611,1.1,5.867C4.428,15.41-.644,11.531.069,7.265Z",
    transform: "translate(97.253 7.638) rotate(-5)",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M27.425,2.4A109.5,109.5,0,0,1,63.755.838a54.59,54.59,0,0,1,1.208,8.6c.43,4.989.411,7.134.411,7.134a92.346,92.346,0,0,0-14.594-1.5c-2.442.146-34.44,2.912-46.2,16.521L0,14.062C5.359,10.275,11.486,5.7,27.425,2.4Z",
    transform: "translate(11.915 164.223) rotate(8)",
    fill: "#ffc431"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(40.171 149.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M1969.417,1292.574l-1.53.295c-5.88,1.12-26.75,5.069-27.484,4.751-.855-.367-10.391-1.627-10.391-1.627.026-.443.727-9.4,12.551-11.513s12.227-1.054,12.509-1.085c.224-.032,8.287-.5,12.239,4.021A8.736,8.736,0,0,1,1969.417,1292.574Z",
    transform: "translate(-1930.012 -1272.74)",
    fill: "#9fc3cc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 19.776,
    cy: 5.104,
    rx: 19.776,
    ry: 5.104,
    transform: "translate(5.125 82.294) rotate(-4.958)",
    fill: "#94b5bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 39.553,
    height: 64.368,
    transform: "translate(0 23.253) rotate(-4.958)",
    fill: "#9fc3cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M1978.846,1438.665c.641,7.385.654,13.415.03,13.469s-1.649-5.888-2.29-13.273-.654-13.416-.03-13.469S1978.205,1431.281,1978.846,1438.665Z",
    transform: "translate(-1969.171 -1393.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M2027.6,1217.742c.039.446-2.73,1.05-6.185,1.35s-6.286.181-6.325-.265,2.73-1.05,6.185-1.35S2027.558,1217.3,2027.6,1217.742Z",
    transform: "translate(-2002.302 -1216.791)",
    fill: "#9fc3cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M2031.556,1345.794c.039.446-2.73,1.05-6.185,1.35s-6.286.181-6.325-.265,2.73-1.05,6.185-1.35S2031.517,1345.348,2031.556,1345.794Z",
    transform: "translate(-2005.666 -1325.599)",
    fill: "#9fc3cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 12.557,
    height: 10.218,
    transform: "translate(12.785 2.036) rotate(-4.958)",
    fill: "#9fc3cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M2022.577,1214.61c.06.688-3.17,1.531-7.213,1.882s-7.37.077-7.43-.612,3.17-1.531,7.213-1.882S2022.518,1213.921,2022.577,1214.61Z",
    transform: "translate(-1996.224 -1213.846)",
    fill: "#433939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M2024.792,1240.144c.06.689-3.17,1.531-7.213,1.882s-7.37.077-7.429-.612,3.17-1.531,7.213-1.882S2024.732,1239.455,2024.792,1240.144Z",
    transform: "translate(-1998.106 -1235.542)",
    fill: "#201d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M0,0S.328,1.141,7.24,1.141,14.7,0,14.7,0V3.852H0Z",
    transform: "translate(11.711 2.035) rotate(-4.958)",
    fill: "#201d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M1999.089,1316.661l5.563,64.127-39.406,3.418-.315-3.635c10.229,2.977,39.316,6.094,32.627-63.615l-.014-.161c-.162-1.717-.354-3.483-.563-5.293A8.738,8.738,0,0,1,1999.089,1316.661Z",
    transform: "translate(-1959.684 -1296.826)",
    fill: "#94b5bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(0 88.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(105.049 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(10.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M3887.432,653.782c.665-2.74,3.08-9.6,5.069-18.61,1.253-5.675,3.187-13.79,7.853-29.92,2.707-9.358,2.908-8.94,6.469-21.252,2.221-7.679,2.626-9.521,5.089-17.8,2.182-7.336,2.584-8.306,3.749-12.725a97.717,97.717,0,0,0,3.244-16.943,37.893,37.893,0,0,0-.016-8.634c-.4-3.089-1.587-8.723-3.146-8.5-1.421.2-2.592,5.195-3.145,7.552-.954,4.068-.632,5.537-1.53,10.816-.4,2.336-.78,3.926-1.434,6.641-1.314,5.459-2.3,8.232-3.863,13.481-2.014,6.768-1.52,6.008-3.6,13.185-.951,3.276-2.315,7.5-5,15.827-2.034,6.295-2.731,8.387-5.015,15.421-2.826,8.7-4.239,13.055-4.641,14.369-6.384,20.857-10.187,34.205-9.95,36.694.194,2.031,2.617,2.19,3.326,2.353C3883.583,656.361,3887.016,655.5,3887.432,653.782Z",
    transform: "translate(-3877.544 -518.263)",
    fill: "#79a00d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M3887.432,653.782c.665-2.74,3.08-9.6,5.069-18.61,1.253-5.675,3.187-13.79,7.853-29.92,2.707-9.358,2.908-8.94,6.469-21.252,2.221-7.679,2.626-9.521,5.089-17.8,2.182-7.336,2.584-8.306,3.749-12.725a97.717,97.717,0,0,0,3.244-16.943,37.893,37.893,0,0,0-.016-8.634c-.4-3.089-1.587-8.723-3.146-8.5-1.421.2-2.592,5.195-3.145,7.552-.954,4.068-.632,5.537-1.53,10.816-.4,2.336-.78,3.926-1.434,6.641-1.314,5.459-2.3,8.232-3.863,13.481-2.014,6.768-1.52,6.008-3.6,13.185-.951,3.276-2.315,7.5-5,15.827-2.034,6.295-2.731,8.387-5.015,15.421-2.826,8.7-4.239,13.055-4.641,14.369-6.384,20.857-10.187,34.205-9.95,36.694.194,2.031,2.617,2.19,3.326,2.353C3883.583,656.361,3887.016,655.5,3887.432,653.782Z",
    transform: "translate(-3877.544 -518.263)",
    fill: "#79a00d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M3927.464,1591.695c-.1-2.2.713-3.665.37-3.863-.392-.227-1.193,1.845-3.371,3.849-1.736,1.6-3.054,1.963-3.126,2.945-.046.618.436,1.043.937,1.484a5.009,5.009,0,0,0,4.156.884c1.108-.116,1.662-.175,1.918-.626C3928.875,1595.437,3927.58,1594.317,3927.464,1591.695Z",
    transform: "translate(-3916.732 -1474.393)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M3927.464,1591.695c-.1-2.2.713-3.665.37-3.863-.392-.227-1.193,1.845-3.371,3.849-1.736,1.6-3.054,1.963-3.126,2.945-.046.618.436,1.043.937,1.484a5.009,5.009,0,0,0,4.156.884c1.108-.116,1.662-.175,1.918-.626C3928.875,1595.437,3927.58,1594.317,3927.464,1591.695Z",
    transform: "translate(-3916.732 -1474.393)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M3979,1340.869c.026-.49-.605-.391-1.165-1.276a6.575,6.575,0,0,1-.589-3.55c.008-.931.107-1.052.11-2.263s0-2.158-.221-2.2c-.265-.046-.628,1.177-1.8,4.187-1.2,3.1-1.733,4.164-1.434,5.337a2.287,2.287,0,0,0,.833,1.342,1.718,1.718,0,0,0,1.239.2C3977.24,1342.5,3978.953,1341.67,3979,1340.869Z",
    transform: "translate(-3963.701 -1245.092)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M3979,1340.869c.026-.49-.605-.391-1.165-1.276a6.575,6.575,0,0,1-.589-3.55c.008-.931.107-1.052.11-2.263s0-2.158-.221-2.2c-.265-.046-.628,1.177-1.8,4.187-1.2,3.1-1.733,4.164-1.434,5.337a2.287,2.287,0,0,0,.833,1.342,1.718,1.718,0,0,0,1.239.2C3977.24,1342.5,3978.953,1341.67,3979,1340.869Z",
    transform: "translate(-3963.701 -1245.092)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M4044.611,1379.577c.616-2.351,1.295-3.637,1.106-3.765s-.789,1.374-2.427,2.928c-.956.907-1.532,1.132-2.079,2.166a3.118,3.118,0,0,0-.483,2.011,1.761,1.761,0,0,0,2.72.8C4044.115,1383.155,4043.911,1382.25,4044.611,1379.577Z",
    transform: "translate(-4023.538 -1284.664)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M4065.179,1179.654c.287-1.746.766-2.607.53-2.794-.346-.275-1.368,1.58-3.583,3.362-1.96,1.576-3.111,1.693-3.173,2.424-.1,1.135,2.6,1.837,3.149,1.981,1.284.334,2.118.552,2.633-.035C4065.423,1183.807,4064.7,1182.545,4065.179,1179.654Z",
    transform: "translate(-4039.885 -1106.606)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M4109.315,1005.645c.2-.711-.825-1.009-1.1-2.552a20.634,20.634,0,0,1,.1-2.668c-.007-1.254-.014-2.36-.361-2.454-.226-.061-.546.317-2.656,4.44-1.08,2.111-1.268,2.545-1.157,3.042.283,1.26,2.15,1.374,3.1,1.257C4107.491,1006.679,4109.082,1006.482,4109.315,1005.645Z",
    transform: "translate(-4080.303 -946.537)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M4173.164,946.534c.4-1.021.819-1.551.69-1.726-.214-.292-1.617.86-2.587,1.859-1.233,1.271-2.417,2.49-2.246,3.5a2.026,2.026,0,0,0,3.155.879C4172.89,950.276,4172.216,948.956,4173.164,946.534Z",
    transform: "translate(-4138.372 -898.925)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M4125.388,888.058c-.294-3.344-.42-3.645-.558-3.637-.261.014-.33,1.128-1,2.806-1.111,2.8-2.432,3.507-2.22,4.516.2.967,1.6,1.2,2.362,1.159a1.594,1.594,0,0,0,1.223-.407C4125.647,892.007,4125.665,891.2,4125.388,888.058Z",
    transform: "translate(-4095.941 -844.927)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M4170.981,835.4c-.033-2.259.576-3.667.271-3.8-.264-.117-.708.947-1.841,2.363-1.82,2.273-2.952,2.371-3.049,3.378-.118,1.217,1.406,2.414,2.828,2.452a2.069,2.069,0,0,0,1.881-.741C4171.561,838.265,4171.012,837.481,4170.981,835.4Z",
    transform: "translate(-4136.002 -797.643)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M4171.635,776.134a31.844,31.844,0,0,0-.692-3.692c-.249-1.237-.3-1.592-.439-1.583-.219.013-.388.86-.956,3.124-.754,3.008-.934,3.421-.7,3.929a1.714,1.714,0,0,0,2.679.485C4171.8,778.033,4171.748,777.4,4171.635,776.134Z",
    transform: "translate(-4138.146 -743.3)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M4205.965,741.727c.436-2.128.576-4.79.111-4.871-.525-.091-.792,3.3-3.2,5.525-.615.569-1.334,1.028-1.39,1.743-.063.825.8,1.451,1.041,1.626a1.643,1.643,0,0,0,1.378.459C4205.123,745.842,4205.712,742.961,4205.965,741.727Z",
    transform: "translate(-4167.441 -712.87)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M4218.5,803c.257-3.429.845-5.387.6-5.443s-.486,2.221-2.023,3.526c-.457.388-.9.583-1.147,1.206a2.534,2.534,0,0,0,.044,1.757c.4,1.012,1.514,1.57,2.072,1.109C4218.416,804.844,4218.412,804.19,4218.5,803Z",
    transform: "translate(-4180.238 -767.189)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M4194.263,707.7c.2-.894-.353-1.407-.7-2.359-.8-2.185.206-4.585-.094-4.653-.248-.056-.588,1.659-1.954,4.491a5.286,5.286,0,0,0-.831,2.338c0,1.049.548,2.254,1.391,2.3a1.984,1.984,0,0,0,1.337-.728A2.947,2.947,0,0,0,4194.263,707.7Z",
    transform: "translate(-4157.769 -680.507)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M4222.384,664.83a11.042,11.042,0,0,0,.271-2.5c-.031-1.027-.155-5.033-.746-4.985-.137.011-.246.233-1.16,3.409-.768,2.669-.918,3.3-.807,4.154.125.959.573,2.111,1.118,2.059.251-.024.465-.3.653-.538A3.81,3.81,0,0,0,4222.384,664.83Z",
    transform: "translate(-4183.926 -641.717)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M4222.384,664.83a11.042,11.042,0,0,0,.271-2.5c-.031-1.027-.155-5.033-.746-4.985-.137.011-.246.233-1.16,3.409-.768,2.669-.918,3.3-.807,4.154.125.959.573,2.111,1.118,2.059.251-.024.465-.3.653-.538A3.81,3.81,0,0,0,4222.384,664.83Z",
    transform: "translate(-4183.926 -641.717)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M4195.362,639.424a4.884,4.884,0,0,0,.1-1.3,18.2,18.2,0,0,0-.306-2.465c-.23-1.42-.229-1.423-.262-1.578-.138-.648-.5-2.157-.7-2.089-.13.046-.056.759-.149,2.013-.145,1.949-.478,2.283-.524,3.934-.028,1-.048,2.181.531,2.556a.732.732,0,0,0,.822,0A1.782,1.782,0,0,0,4195.362,639.424Z",
    transform: "translate(-4160.305 -619.03)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M4251.44,704.248c.172-1.444.221-1.776.088-1.837-.345-.16-1.656,1.619-2,3.6-.121.7.019.614-.081,2.107-.135,2.036-.452,3.076-.209,3.192.214.1.711-.588,1-1.067C4250.935,709.065,4250.986,708.079,4251.44,704.248Z",
    transform: "translate(-4210.094 -682.037)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M4245.494,621.44c.111-1.995-.276-4.07-.723-4.039-.271.019-.551.814-.93,1.9a6.009,6.009,0,0,0-.447,1.691c-.059,1.034.4,1.291.662,2.476a16.212,16.212,0,0,1,.092,2.779C4244.384,626.286,4245.35,624.019,4245.494,621.44Z",
    transform: "translate(-4204.937 -605.971)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M4212.552,603.222c.512-1.434.508-1.409.519-1.461.258-1.241-.15-1.663-.505-4.218-.155-1.116-.143-1.507-.327-1.537-.434-.072-1.219,1.977-1.567,3.11a6.237,6.237,0,0,0-.4,1.98,8.479,8.479,0,0,0,.568,2.3c.435,1.678.315,2.634.555,2.633C4211.561,606.031,4211.7,605.6,4212.552,603.222Z",
    transform: "translate(-4175.306 -586.822)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M4248.546,657.854c.739-.906,1.007-.834,1.276-1.422.721-1.58-.352-3.979-.63-3.867-.117.047,0,.5-.139,1.549-.133,1.016-.363,1.529-1.464,4.556a11.333,11.333,0,0,0-.6,1.831A14.126,14.126,0,0,1,4248.546,657.854Z",
    transform: "translate(-4208.156 -637.436)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M4237.433,575.206c.083-.229.138-.379.166-.468.534-1.649-.6-4.512-1.2-4.3-.454.162-.542,2.062-.575,2.776-.1,2.1.353,4.1.723,4.039C4236.7,577.232,4236.944,576.556,4237.433,575.206Z",
    transform: "translate(-4198.16 -563.936)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M4206.425,557.51a4.839,4.839,0,0,0,.7-1.389,4.328,4.328,0,0,0-.209-2.158c-.295-1.146-.461-1.789-.711-1.76-.522.061-1.078,3.028-1.2,5.4-.074,1.459,0,2.971.229,2.969S4205.481,559.213,4206.425,557.51Z",
    transform: "translate(-4170.564 -547.624)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M4262.054,592.208c.042-.918.1-2.054-.3-2.195-.439-.157-1.4.931-1.442,1.89-.029.613.337.7.642,1.665a19.985,19.985,0,0,1,.3,2.195C4261.462,595.773,4261.969,594.039,4262.054,592.208Z",
    transform: "translate(-4220.083 -581.448)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M4255.732,544.885a14.84,14.84,0,0,0-.763-3.175c-.078-.222-.353-.161-.411.091-.1.415-.221.951-.346,1.464a4.651,4.651,0,0,0-.48,1.611c-.01.633.044,2.427.551,2.5C4254.735,547.436,4255.859,546.092,4255.732,544.885Z",
    transform: "translate(-4214.193 -538.112)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M4221.234,526.683a3.765,3.765,0,0,0-.306-2.465c-.5-1.156-.138-2.25-.413-2.308s-.951.954-1.083,2.035c-.161,1.32,1.24,4.1,1.542,3.9C4221.107,527.762,4220.934,527.306,4221.234,526.683Z",
    transform: "translate(-4183.488 -520.514)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M4237.1,510.614c-.084-.668-.225-1.8-.849-1.95a1.211,1.211,0,0,0-1.161.666c-.084.14-.389.7.04,2.491.181.756.724,3.02,1.294,2.866C4236.958,514.542,4237.313,512.323,4237.1,510.614Z",
    transform: "translate(-4197.346 -508.647)",
    fill: "#b1c920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M4183.591,708.864c.352-.594.667-.847.678-1.33.007-.26-.08-.4-.448-1.052-.658-1.17-.687-1.277-.787-1.256-.389.084-.682,1.889-.717,3.321-.034,1.392.167,2.8.4,2.772C4182.931,711.3,4182.829,710.152,4183.591,708.864Z",
    transform: "translate(-4150.282 -684.563)",
    fill: "#b1c920"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(9.561 16.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M3881.47,801.5c1.019-8.091,4.384-15.829,6.509-23.762,1.876-7,3.5-12.3,4.625-15.94,1.064-3.452,2.886-9.343,5.513-16.816,4.109-11.691,4.612-11.394,7.1-19.42,1.8-5.8,2.023-7.517,3.994-13.005,1.077-3,2.978-7.966,4-10.639,1.062-2.775,1.593-4.163,1.746-4.521,2.643-6.2,4.109-6.82,6.52-12.332a60.106,60.106,0,0,0,2.8-8.3c1.643-5.681,1.244-6.19,1.1-6.319-1.079-.971-5.323,3.7-6.678,5.185a50.182,50.182,0,0,0-5.848,7.835c-3.209,5.456-4.6,9.952-6.352,15.148-2.128,6.3-4.649,12.447-6.878,18.71-7.831,22-7.323,20.1-9.788,27.36-5.767,16.97-4.294,14.838-8.036,25.206-7,19.411-9.628,31.158-9.9,33.43-.193,1.638,2.731,3.613,5.229,3.181a5.472,5.472,0,0,0,3.545-2.522A6.415,6.415,0,0,0,3881.47,801.5Z",
    transform: "translate(-3871.896 -669.916)",
    fill: "#a6c622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M3881.47,801.5c1.019-8.091,4.384-15.829,6.509-23.762,1.876-7,3.5-12.3,4.625-15.94,1.064-3.452,2.886-9.343,5.513-16.816,4.109-11.691,4.612-11.394,7.1-19.42,1.8-5.8,2.023-7.517,3.994-13.005,1.077-3,2.978-7.966,4-10.639,1.062-2.775,1.593-4.163,1.746-4.521,2.643-6.2,4.109-6.82,6.52-12.332a60.111,60.111,0,0,0,2.8-8.3c1.643-5.681,1.244-6.19,1.1-6.319-.3-.266-.829-.108-1.475.29-.16.626-.357,1.348-.6,2.182a60.07,60.07,0,0,1-2.8,8.3c-2.411,5.512-3.876,6.129-6.52,12.332-.153.358-.684,1.745-1.746,4.521-1.023,2.673-2.924,7.64-4,10.639-1.97,5.488-2.194,7.209-3.994,13.005-2.492,8.026-3.315,7.609-7.1,19.42-20.258,63.134-23.9,61.259-24.943,60.48-.159.789-.256,1.362-.3,1.711-.193,1.638,2.731,3.613,5.229,3.181a5.472,5.472,0,0,0,3.545-2.522A6.414,6.414,0,0,0,3881.47,801.5Z",
    transform: "translate(-3871.896 -669.917)",
    fill: "#95b71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M4042.654,1477.994c-.229-.088-.483,1.195-1.709,2.5-1.946,2.067-3.991,1.689-4.263,2.865-.132.569.222,1.192.779,2.173a4.563,4.563,0,0,1,.846,1.8c.063.417.02.64.132.7.328.182,1.376-1.362,2-2.462C4042.381,1482.167,4043.058,1478.15,4042.654,1477.994Z",
    transform: "translate(-4019.337 -1392.697)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M4042.654,1478a.067.067,0,0,0-.056.005,20.45,20.45,0,0,1-2.064,5.338c-.627,1.1-1.675,2.644-2,2.462-.112-.062-.068-.284-.132-.7a4.564,4.564,0,0,0-.846-1.8c-.125-.219-.238-.42-.339-.607a1.038,1.038,0,0,0-.532.668c-.132.569.222,1.192.779,2.173a4.565,4.565,0,0,1,.846,1.8c.063.418.02.64.132.7.328.182,1.376-1.362,2-2.462C4042.381,1482.17,4043.058,1478.152,4042.654,1478Z",
    transform: "translate(-4019.337 -1392.699)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M4092.775,1236.957c.1-.438-.13-.667-.346-1.3-.2-.59-.251-1.107-.181-3.411.087-2.891.223-4.03.072-4.047s-.341,1.12-1.107,2.836a6.169,6.169,0,0,1-1.74,2.75c-1.01.7-1.711.068-2.088.66-.464.729.121,2.433,1.026,3.309a2.634,2.634,0,0,0,2.149.741C4091.382,1238.384,4092.585,1237.823,4092.775,1236.957Z",
    transform: "translate(-4064.59 -1169.157)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M4101.43,1236.957c.1-.438-.13-.667-.347-1.3-.2-.59-.25-1.107-.181-3.412.087-2.89.223-4.029.072-4.047s-.341,1.12-1.107,2.836l-.117.261c0,.051,0,.1,0,.152-.07,2.3-.021,2.821.181,3.412.217.634.442.863.346,1.3-.19.867-1.393,1.427-2.215,1.535a2.46,2.46,0,0,1-1.165-.125c.056.064.114.124.172.182a2.634,2.634,0,0,0,2.149.741C4100.037,1238.384,4101.24,1237.823,4101.43,1236.957Z",
    transform: "translate(-4073.246 -1169.157)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M4118.5,1085.549c.247-.653-.424-.99-.739-2.619a18.72,18.72,0,0,1-.063-3.305c.008-2.759-.039-2.837-.1-2.859-.274-.095-3.086,6.817-3.526,8.832-.215.988,1.446.856,1.845.9C4116.724,1086.584,4118.173,1086.408,4118.5,1085.549Z",
    transform: "translate(-4088.597 -1033.641)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M4118.508,1085.549c.247-.653-.424-.99-.739-2.619a18.72,18.72,0,0,1-.063-3.305c.008-2.759-.04-2.837-.1-2.859a10.246,10.246,0,0,0-1.242,2.508,15.416,15.416,0,0,0,.064,2.9c.315,1.629.986,1.966.739,2.619-.325.859-1.774,1.035-2.586.948-.1-.011-.3-.01-.518-.021-.056.855,1.48.736,1.862.777C4116.734,1086.584,4118.183,1086.408,4118.508,1085.549Z",
    transform: "translate(-4088.607 -1033.641)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M4172.482,1132.436c.914-4.039,1.491-5.643,1.27-5.735-.2-.081-.572,1.2-1.871,3.164-1.578,2.382-2.753,3.107-2.736,4.442a2.6,2.6,0,0,0,.465,1.408c.278.406.555,1.08,1.1.864C4171.343,1136.331,4171.888,1135.06,4172.482,1132.436Z",
    transform: "translate(-4137.903 -1078.325)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M4175.322,1132.436c.914-4.039,1.491-5.643,1.27-5.735-.136-.057-.362.551-.926,1.59-.218.859-.5,1.978-.819,3.4-.593,2.624-1.139,3.9-1.768,4.142-.333.131-.567-.065-.761-.33.058.1.107.175.131.211.278.406.555,1.08,1.1.864C4174.183,1136.331,4174.729,1135.06,4175.322,1132.436Z",
    transform: "translate(-4140.743 -1078.325)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M4170.45,1035.555c.85-5.036,1.616-6.992,1.255-7.12-.317-.112-.641,1.483-2.24,3.365-1.8,2.119-3.623,2.725-3.621,3.875a2.2,2.2,0,0,0,.368.915,3,3,0,0,0,1.436,1.546,1.86,1.86,0,0,0,1.846-.218A3.9,3.9,0,0,0,4170.45,1035.555Z",
    transform: "translate(-4134.95 -990.386)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M4176.489,1035.555c.85-5.036,1.616-6.992,1.254-7.12-.259-.091-.524.962-1.49,2.381-.216,1.007-.472,2.272-.735,3.835a3.9,3.9,0,0,1-.957,2.363,1.859,1.859,0,0,1-1.846.218c-.042-.016-.083-.034-.124-.053a2.355,2.355,0,0,0,1.095.958,1.859,1.859,0,0,0,1.846-.218A3.9,3.9,0,0,0,4176.489,1035.555Z",
    transform: "translate(-4140.988 -990.386)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M4180.028,953.673c.185-.613-.179-.982-.4-1.779a9.107,9.107,0,0,1,.285-4.236c.255-1.181.5-1.671.364-1.779-.275-.217-1.6,1.509-2.493,2.884-1.089,1.687-2.578,3.993-2.047,5.467a1.751,1.751,0,0,0,1,1c1.172.53,2.371-.484,2.6-.68A1.85,1.85,0,0,0,4180.028,953.673Z",
    transform: "translate(-4143.707 -916.495)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M4200.4,953.673c.185-.613-.179-.982-.4-1.779a9.1,9.1,0,0,1,.284-4.236c.256-1.181.5-1.671.364-1.779-.173-.137-.764.5-1.4,1.327-.077.281-.192.677-.31,1.22a9.114,9.114,0,0,0-.285,4.236c.218.8.583,1.165.4,1.779a1.805,1.805,0,0,1-.663.86,3.719,3.719,0,0,0,1.321-.748A1.85,1.85,0,0,0,4200.4,953.673Z",
    transform: "translate(-4164.073 -916.495)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M4189.762,909.938a5.949,5.949,0,0,0,.243-1.558c.058-.947-.017-2.323-.319-2.343-.177-.011-.391.445-.784,1.5-1.06,2.852-1.747,4.7-1.382,4.974S4189.259,911.5,4189.762,909.938Z",
    transform: "translate(-4154.258 -880.857)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M4189.762,909.938a5.949,5.949,0,0,0,.243-1.558c.058-.947-.017-2.323-.319-2.343-.049,0-.1.032-.16.1a8.654,8.654,0,0,1,.071,1.847,5.948,5.948,0,0,1-.243,1.558,4.688,4.688,0,0,1-1.93,2.566c-.014.206.016.341.1.4C4187.88,912.786,4189.259,911.5,4189.762,909.938Z",
    transform: "translate(-4154.258 -880.857)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M4234.957,931.1c.552-1.758,1.322-4.531,1.113-4.607-.093-.034-.277.509-.708,1.266-1.549,2.72-3.439,3.2-3.508,4.636a2.961,2.961,0,0,0,.346,1.3c.236.568.556,1.336.952,1.313C4233.727,934.973,4234.268,933.286,4234.957,931.1Z",
    transform: "translate(-4194.02 -899.159)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M4241.454,931.1c.553-1.758,1.322-4.531,1.113-4.607-.093-.034-.276.509-.708,1.266-.141.248-.286.477-.431.691-.208.763-.452,1.587-.664,2.261-.627,1.994-1.132,3.571-1.652,3.862.16.261.338.448.537.437C4240.225,934.973,4240.767,933.286,4241.454,931.1Z",
    transform: "translate(-4200.518 -899.159)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M4227.205,855.183a11.852,11.852,0,0,0,1.337-3.873c.482-2.712.217-5.6-.245-5.6-.146,0-.25.291-.935,1.976-.884,2.175-1.325,3.263-1.489,3.558-1.105,1.989-1.948,1.972-2.176,3.322a7.958,7.958,0,0,0,.163,2.355c.166,1.144.318,1.289.438,1.333s.367.068,1.432-1.148A11.442,11.442,0,0,0,4227.205,855.183Z",
    transform: "translate(-4186.687 -826.869)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M4229.2,855.183a11.852,11.852,0,0,0,1.336-3.874c.483-2.712.217-5.6-.245-5.6-.044,0-.085.027-.139.112a16.372,16.372,0,0,1-.186,4.362,11.846,11.846,0,0,1-1.336,3.874,11.444,11.444,0,0,1-1.475,1.921c-.735.839-1.088,1.085-1.27,1.145.154.96.294,1.089.407,1.131s.366.068,1.432-1.148A11.454,11.454,0,0,0,4229.2,855.183Z",
    transform: "translate(-4188.677 -826.869)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M4222.979,821.523a9.472,9.472,0,0,0,.542-3.294c-.02-1.217-.281-3.113-.79-3.1-.209.007-.371.338-.78,1.176-1.762,3.606-1.995,4.079-1.97,4.9a2.8,2.8,0,0,0,.527,1.692c.092.11.666.767,1.308.516C4222.384,823.2,4222.67,822.394,4222.979,821.523Z",
    transform: "translate(-4183.396 -799.508)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M4228.763,821.523a9.476,9.476,0,0,0,.542-3.294c-.021-1.217-.282-3.113-.79-3.1-.154.005-.283.186-.5.613a11.276,11.276,0,0,1,.23,2.1,9.464,9.464,0,0,1-.542,3.294c-.308.87-.594,1.675-1.163,1.9a.822.822,0,0,1-.1.03,1.132,1.132,0,0,0,1.156.355C4228.169,823.2,4228.455,822.394,4228.763,821.523Z",
    transform: "translate(-4189.181 -799.508)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M4281.305,849.009c.522-1.562.887-3.23.7-3.305-.206-.083-.631,1.915-2.205,3.574-1.191,1.256-2.06,1.284-2.267,2.174-.221.954.477,2.212,1.183,2.181C4279.778,853.586,4280.768,850.62,4281.305,849.009Z",
    transform: "translate(-4234.862 -826.862)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M4282.951,849.009c.522-1.562.887-3.23.7-3.305-.14-.056-.383.852-1.019,1.96-.063.208-.129.419-.2.627-.538,1.611-1.528,4.577-2.59,4.624a.778.778,0,0,1-.512-.192c.228.526.628.928,1.031.91C4281.423,853.586,4282.413,850.62,4282.951,849.009Z",
    transform: "translate(-4236.508 -826.862)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M4280.655,805.337c.348-1.382.737-3.733.282-3.909-.423-.164-1.9,2.871-2.361,3.586-.66,1.026-1.159,1.049-1.559,2.024a4.193,4.193,0,0,0-.286,1.215c-.046.453-.144,1.421.214,1.716.486.4,1.685-.546,2.4-1.472A7.984,7.984,0,0,0,4280.655,805.337Z",
    transform: "translate(-4234.14 -787.236)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M4280.661,805.341c.348-1.382.737-3.733.281-3.909a.134.134,0,0,0-.1.013,16.747,16.747,0,0,1-.485,2.96,7.984,7.984,0,0,1-1.312,3.16c-.691.9-1.839,1.814-2.351,1.505a1.242,1.242,0,0,0,.261.9c.486.4,1.686-.546,2.4-1.472A7.985,7.985,0,0,0,4280.661,805.341Z",
    transform: "translate(-4234.146 -787.241)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M4254.776,758.69c.08-.359.686-3.108.322-3.238-.15-.053-.361.375-1.115,1.586-1.523,2.445-2.031,2.889-2,3.712.023.534.242.469.473,1.542.246,1.141.1,1.694.26,1.731C4253.073,764.106,4254.156,761.464,4254.776,758.69Z",
    transform: "translate(-4212.039 -746.094)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M4259.755,758.69c.081-.359.687-3.108.322-3.238-.09-.032-.2.11-.44.491-.111.828-.326,1.8-.371,2a20.462,20.462,0,0,1-1.716,5c.087.7.025,1.05.15,1.08C4258.052,764.106,4259.135,761.464,4259.755,758.69Z",
    transform: "translate(-4217.017 -746.094)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M4273.461,789.509c-.25-.269-1.04.342-1.354.584a7.3,7.3,0,0,0-1.3,1.523c-1.1,1.5-1.163,1.9-1.147,2.166a3.206,3.206,0,0,0,.177.718c.165.53.247.8.388.856.4.173,1.252-1.179,1.537-1.637C4272.555,792.444,4273.871,789.948,4273.461,789.509Z",
    transform: "translate(-4227.855 -776.516)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M4273.461,789.732a.191.191,0,0,0-.054-.041,17.129,17.129,0,0,1-1.684,3.425c-.284.458-1.134,1.811-1.537,1.637-.141-.06-.223-.326-.387-.856-.032-.1-.059-.19-.082-.268a.941.941,0,0,0-.055.375,3.212,3.212,0,0,0,.177.718c.164.53.247.8.387.856.4.173,1.252-1.179,1.537-1.637C4272.555,792.667,4273.87,790.172,4273.461,789.732Z",
    transform: "translate(-4227.855 -776.739)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M4282.091,749.114c.219-.25.258-.433.7-1.862.494-1.619.639-2.026.523-2.118-.1-.08-.305.141-.878.683-1.618,1.529-1.953,1.631-2.277,2.367-.112.253-.029.143-.4,1.243-.342,1.025-.492,1.352-.407,1.436.121.119.5-.464,1.33-.987C4281.487,749.367,4281.7,749.557,4282.091,749.114Z",
    transform: "translate(-4236.507 -736.85)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M4282.092,749.114c.219-.25.258-.433.7-1.862.494-1.619.639-2.026.522-2.118-.084-.067-.245.081-.638.456-.089.294-.208.677-.359,1.173-.437,1.429-.477,1.612-.7,1.862-.389.443-.6.254-1.41.762a5.379,5.379,0,0,0-.578.422c-.249.727-.351.981-.277,1.053.12.119.5-.464,1.33-.987C4281.488,749.368,4281.7,749.558,4282.092,749.114Z",
    transform: "translate(-4236.507 -736.851)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M4324.063,788.5c1.112-2.554,1.565-3.615,1.436-3.708s-.472.868-1.333,1.314c-1,.519-1.759-.133-2.1.391-.176.267,0,.467-.03,1.369-.042,1.149-.351,1.4-.313,2.256.027.62.237,1.57.61,1.589C4322.647,791.729,4322.948,791.061,4324.063,788.5Z",
    transform: "translate(-4274.439 -772.351)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M4326.639,788.5c1.113-2.554,1.565-3.615,1.436-3.708-.09-.065-.31.454-.776.906-.24.591-.6,1.431-1.1,2.565-.967,2.22-1.322,3.017-1.606,3.178.086.159.189.263.311.27C4325.224,791.729,4325.524,791.061,4326.639,788.5Z",
    transform: "translate(-4277.016 -772.351)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M4286.283,710.544a5.119,5.119,0,0,0,.795-1.7c.682-1.776,1.179-2.391,1.059-2.525-.078-.085-.332.112-2.126,1.894-1.54,1.529-1.917,1.945-2.06,2.64-.164.8.048,1.654.324,1.688.214.026.328-.455.964-1.113C4285.753,710.9,4285.919,710.966,4286.283,710.544Z",
    transform: "translate(-4240.592 -702.118)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M4286.4,710.545a5.11,5.11,0,0,0,.795-1.7c.682-1.776,1.179-2.391,1.059-2.525-.061-.067-.232.042-1.179.961-.094.221-.2.466-.3.74a5.141,5.141,0,0,1-.794,1.7c-.364.422-.53.357-1.044.888-.583.6-.728,1.056-.912,1.107.044.457.193.808.368.829.214.026.328-.455.964-1.113C4285.87,710.9,4286.037,710.967,4286.4,710.545Z",
    transform: "translate(-4240.709 -702.119)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M4313.884,731.388c.722-1.924,1.182-4.187.909-4.284-.125-.045-.269.419-1.012,1.424s-.9.953-1.419,1.744a8.081,8.081,0,0,0-.954,2.035c-.236.717-.405,1.234-.224,1.5.229.333.9.1,1.332-.2A4.263,4.263,0,0,0,4313.884,731.388Z",
    transform: "translate(-4264.947 -720.728)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M4314,731.389c.721-1.924,1.182-4.187.909-4.284-.116-.041-.249.354-.858,1.211a20.436,20.436,0,0,1-.822,2.807,4.269,4.269,0,0,1-1.368,2.221,2.321,2.321,0,0,1-.624.3.412.412,0,0,0,.063.159c.229.333.9.1,1.332-.2A4.262,4.262,0,0,0,4314,731.389Z",
    transform: "translate(-4265.058 -720.728)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M4338.345,730.849a27.409,27.409,0,0,0,1.068-4.623,16.942,16.942,0,0,1-1.931,2.553,4.72,4.72,0,0,0-.843.892,6.619,6.619,0,0,0-.662,1.282c-.523,1.2-.785,1.806-.642,2.012.157.225.66-.036,1.039-.233A4.038,4.038,0,0,0,4338.345,730.849Z",
    transform: "translate(-4286.593 -719.941)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M4338.346,730.849a27.344,27.344,0,0,0,1.067-4.623c-.071-.044-.254.36-.6.917a24.113,24.113,0,0,1-.8,3.014,4.04,4.04,0,0,1-1.97,1.882,3.866,3.866,0,0,1-.638.285c-.115.331-.146.536-.073.64.156.225.659-.036,1.038-.233A4.041,4.041,0,0,0,4338.346,730.849Z",
    transform: "translate(-4286.594 -719.941)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M4324.181,680.666a11.006,11.006,0,0,0,.011-1.309c.145-1.566,1.149-2.455,1-2.675-.172-.261-1.84.626-2.792,2.387a9.218,9.218,0,0,0-.814,2.872c-.139.74-.152,1.087.007,1.25.291.3.979-.187,1.168-.32A3.719,3.719,0,0,0,4324.181,680.666Z",
    transform: "translate(-4274.231 -675.567)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M4324.279,680.666a10.9,10.9,0,0,0,.011-1.309c.145-1.566,1.15-2.455,1-2.675-.079-.119-.468,0-.958.333a4.839,4.839,0,0,0-.759,2.1,10.7,10.7,0,0,1-.012,1.309,3.716,3.716,0,0,1-1.413,2.205,3.206,3.206,0,0,1-.56.327.418.418,0,0,0,.1.239c.291.3.979-.187,1.167-.32A3.718,3.718,0,0,0,4324.279,680.666Z",
    transform: "translate(-4274.329 -675.567)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M4352.961,670.787c.794-1.617.975-3.92.349-4.279-.548-.315-1.771.828-2.366,2.009a8.26,8.26,0,0,0-.707,3.171,10.131,10.131,0,0,1-.087,1.546c-.168,1.044-.492,1.628-.391,1.7s.6-.595,1.483-1.787A26.215,26.215,0,0,0,4352.961,670.787Z",
    transform: "translate(-4299.519 -666.455)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M4352.961,670.787c.8-1.617.976-3.92.35-4.279-.222-.128-.556-.016-.913.242a.387.387,0,0,1,.128.045c.626.36.446,2.662-.349,4.279a26.215,26.215,0,0,1-1.718,2.363c-.187.253-.354.482-.506.686-.138.487-.259.764-.192.814.114.086.6-.595,1.483-1.787A25.6,25.6,0,0,0,4352.961,670.787Z",
    transform: "translate(-4299.519 -666.455)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(23.313 55.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M4095.139,1202.261c.247-.812.52-1.62.814-2.411.385-1.034.815-2.058,1.281-3.054a.962.962,0,0,0-.222-1.2c-.35-.228-.82-.023-1.042.45-.492,1.052-.946,2.132-1.352,3.223-.31.833-.6,1.684-.858,2.541a.858.858,0,0,0,.438,1.123A.838.838,0,0,0,4095.139,1202.261Z",
    transform: "translate(-4093.708 -1195.503)",
    fill: "#bad32a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(8.138 68.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M3950.752,1358.312c.593-1.8,1.222-3.62,1.875-5.428.5-1.382.867-2.356,1.192-3.216.406-1.074.727-1.923,1.127-3.1.669-1.967.961-3.1,1.4-4.807.223-.863.475-1.841.836-3.169,1.67-6.137,3.292-10.992,4.6-14.893.549-1.643,1.116-3.292,1.688-4.916a.892.892,0,0,0-.363-1.146.805.805,0,0,0-.987.607c-.576,1.635-1.147,3.3-1.7,4.95-1.313,3.93-2.948,8.82-4.636,15.023-.365,1.343-.631,2.372-.844,3.2-.442,1.717-.71,2.753-1.35,4.634-.387,1.139-.7,1.972-1.1,3.026-.328.868-.7,1.851-1.2,3.249-.66,1.828-1.3,3.67-1.9,5.488a.878.878,0,0,0,.395,1.135A.819.819,0,0,0,3950.752,1358.312Z",
    transform: "translate(-3949.329 -1317.594)",
    fill: "#bad32a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M3941.406,1678.039c.292-1.22-.744-1.565-.932-3.6-.17-1.846.549-2.973.211-3.211-.492-.346-2.275,1.874-3.392,3.953a7.152,7.152,0,0,0-1.091,3.1c-.08,1.361.35,3.091,1.247,3.253.408.074.862-.3,1.752-1.038C3940.547,1679.375,3941.22,1678.813,3941.406,1678.039Z",
    transform: "translate(-3929.435 -1565.59)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M3945.451,1678.039c.292-1.22-.744-1.565-.932-3.6-.17-1.845.549-2.973.211-3.21-.266-.187-.909.376-1.62,1.261a6.449,6.449,0,0,0-.034,1.453c.188,2.04,1.224,2.384.932,3.6-.185.774-.858,1.335-2.2,2.458a10.961,10.961,0,0,1-1.091.846,1.2,1.2,0,0,0,.781.689c.408.074.862-.3,1.752-1.038C3944.593,1679.375,3945.266,1678.813,3945.451,1678.039Z",
    transform: "translate(-3933.48 -1565.59)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M4015,1365.506c.223-.763-.416-1.234-.787-2.307-.838-2.424.566-5.392.323-5.47-.191-.061-.92,1.812-1.271,2.714-1.324,3.4-.885,3.248-1.932,5.9-.322.816-.562,1.333-.4,1.57.262.382,1.335-.3,2.513-1.038C4014.825,1366.006,4014.957,1365.652,4015,1365.506Z",
    transform: "translate(-3996.273 -1285.074)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M4015,1365.506c.223-.763-.416-1.234-.787-2.307-.838-2.424.566-5.392.323-5.47-.191-.061-.92,1.812-1.271,2.714-.11.283-.208.54-.3.777a5.147,5.147,0,0,0,.263,1.458c.371,1.073,1.011,1.544.787,2.307-.043.146-.175.5-1.553,1.369-.537.339-1.052.663-1.479.881-.109.319-.146.544-.054.679.262.382,1.335-.3,2.514-1.038C4014.826,1366.006,4014.958,1365.652,4015,1365.506Z",
    transform: "translate(-3996.274 -1285.074)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M3944.568,1706.808c-.181-.072-.828,1.05-1.078,2.189-.232,1.053-.157,2.273.035,2.278C3943.889,1711.285,3944.9,1706.941,3944.568,1706.808Z",
    transform: "translate(-3935.836 -1597.463)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M4055.1,1513.611c-.067-.083-.322.295-.941.563-.78.337-1.238.109-1.324.332-.1.257.364.943.928.911C4054.6,1515.368,4055.224,1513.766,4055.1,1513.611Z",
    transform: "translate(-4033.806 -1424.564)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M4022.931,1416.494c.222-.632-.128-1.342-.294-1.3-.122.03-.092.453-.406,1.272-.21.549-.366.731-.313.81C4022.014,1417.416,4022.71,1417.122,4022.931,1416.494Z",
    transform: "translate(-4006.141 -1336.498)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M4097.268,1283.146c-.094-.073-.419.7-1.151.982-.545.213-.891-.01-.964.16-.1.237.415,1.034,1,.934C4096.968,1285.083,4097.405,1283.252,4097.268,1283.146Z",
    transform: "translate(-4071.677 -1218.327)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M4178.667,1084.811c.194-.5.166-.567.147-.59-.087-.111-.422.121-.557.231a1.178,1.178,0,0,0-.269.286.9.9,0,0,0-.2.626c.041.215.222.385.385.346S4178.446,1085.385,4178.667,1084.811Z",
    transform: "translate(-4145.632 -1040.287)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M4174.141,1184.576c.1-.318.258-.985.116-1.065s-.605.444-.783,1.056c-.143.491-.116,1.083.035,1.116C4173.676,1185.722,4173.989,1185.066,4174.141,1184.576Z",
    transform: "translate(-4141.694 -1129.161)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M4123.677,1134.043c.213-.681-.234-1.4-.42-1.339-.128.046-.077.448-.356,1.309-.19.585-.335.776-.274.86C4122.738,1135.031,4123.471,1134.7,4123.677,1134.043Z",
    transform: "translate(-4096.261 -1083.698)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M4181.41,991.518c.125-.369-.638-.6-.772-1.4-.181-1.072.914-2.359.847-2.417a2.827,2.827,0,0,0-.683.947,3.746,3.746,0,0,0-.574,1.92c.006.155.043,1.071.526,1.216A.565.565,0,0,0,4181.41,991.518Z",
    transform: "translate(-4147.82 -953.937)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M4237.5,968.17c.267-.769.516-1.106.45-1.174s-.536.283-.791.811a2.456,2.456,0,0,0-.223,1.056c-.006.327.042.789.131.784A13.5,13.5,0,0,0,4237.5,968.17Z",
    transform: "translate(-4198.565 -935.398)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M4230.574,905.394c.341-.516.547-.528.793-1.056.271-.582.341-1.25.225-1.3s-.291.505-.933,1.255c-.449.524-.594.524-.737.879a3.706,3.706,0,0,0-.142,1.281c-.01.456-.018.8.048.8A10.333,10.333,0,0,1,4230.574,905.394Z",
    transform: "translate(-4192.161 -878.168)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M4226.748,849.135c.134-.844.245-1.546.124-1.583s-.422.548-.573,1.083a3.979,3.979,0,0,0-.134,1.136c0,.423.038,1.193.155,1.186A5.855,5.855,0,0,0,4226.748,849.135Z",
    transform: "translate(-4188.93 -828.518)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M4257.462,787.907c.319-1.122.31-1.216.279-1.234-.088-.05-.422.468-.62.87a2.665,2.665,0,0,0-.275.743c-.095.512-.007,1.075.114,1.074C4256.992,789.36,4257.059,789.322,4257.462,787.907Z",
    transform: "translate(-4216.352 -774.036)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M4282.056,839.529c-.043-.03-.186.281-.625.769-.424.47-.548.467-.743.778-.319.508-.42,1.2-.293,1.278.162.1.725-.794.848-.988A4.992,4.992,0,0,0,4282.056,839.529Z",
    transform: "translate(-4237.413 -821.337)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M4275.27,806.631c.373-1,.7-1.508.646-1.55-.034-.027-.163.171-.779,1.012s-.8,1.065-.776,1.358c.02.256.194.495.347.464C4274.9,807.877,4274.965,807.447,4275.27,806.631Z",
    transform: "translate(-4232.06 -790.509)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M4283.22,889.028c-.081-.106-.553.235-.852.642a1.843,1.843,0,0,0-.315.63c-.04.143-.138.572-.047.624C4282.211,891.042,4283.369,889.226,4283.22,889.028Z",
    transform: "translate(-4238.87 -865.618)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M4326.447,804.6c.206-.713.1-.874.063-.914a.432.432,0,0,0-.633.077c-.154.192-.113.458-.118.846-.012,1.109-.374,1.724-.263,1.781C4325.631,806.462,4326.173,805.552,4326.447,804.6Z",
    transform: "translate(-4277.803 -789.17)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M4345.56,754.636c-.09-.073-.514.488-.618.624-.384.508-.9,1.338-.8,1.447s.74-.433,1.138-1.184C4345.465,755.168,4345.634,754.7,4345.56,754.636Z",
    transform: "translate(-4294.496 -745.362)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M4317.735,758.4c.194-.5.27-1.082.167-1.124s-.341.414-.48.672c-.313.58-.715,1.522-.592,1.618S4317.463,759.089,4317.735,758.4Z",
    transform: "translate(-4270.047 -747.726)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M4361.083,685.084c.068-.4.055-.887-.054-.905-.125-.021-.349.576-.511,1.006-.183.486-.577,1.534-.44,1.621S4360.917,686.061,4361.083,685.084Z",
    transform: "translate(-4308.744 -682.316)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M4326.768,702.309c.127-.472.249-1.145.148-1.18s-.359.493-.517.905a3.238,3.238,0,0,0-.3,1.769C4326.221,703.837,4326.578,703.014,4326.768,702.309Z",
    transform: "translate(-4278.32 -697.483)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M4289.537,765.071c-.087-.085-.507.382-.687.6-.2.239-.57.752-.5.861s.468-.126.761-.477C4289.422,765.682,4289.615,765.148,4289.537,765.071Z",
    transform: "translate(-4244.571 -754.698)",
    fill: "#dbf279"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(2.806 6.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M3817.575,713.908c.586-2.755,2.806-9.687,4.534-18.739,1.089-5.7,2.789-13.86,6.992-30.115,2.439-9.43,2.653-9.024,5.862-21.431,2-7.738,2.353-9.588,4.579-17.934,1.973-7.4,2.347-8.378,3.385-12.826a97.131,97.131,0,0,0,2.751-17,37.3,37.3,0,0,0-.273-8.586c-.492-3.053-1.854-8.6-3.412-8.309-1.421.267-2.448,5.285-2.932,7.655-.837,4.089-.469,5.535-1.213,10.827-.33,2.342-.667,3.94-1.242,6.67-1.157,5.489-2.065,8.292-3.477,13.583-1.821,6.823-1.347,6.044-3.226,13.277-.858,3.3-2.1,7.569-4.553,15.969-1.854,6.353-2.491,8.465-4.575,15.566-2.578,8.784-3.867,13.177-4.231,14.5-5.788,21.034-9.209,34.483-8.9,36.947.255,2.011,2.694,2.058,3.41,2.188C3813.787,716.649,3817.208,715.632,3817.575,713.908Z",
    transform: "translate(-3807.625 -577.813)",
    fill: "#a6c622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M3817.575,713.908c.586-2.755,2.806-9.687,4.534-18.739,1.089-5.7,2.789-13.86,6.992-30.115,2.439-9.43,2.653-9.024,5.862-21.431,2-7.738,2.353-9.588,4.579-17.934,1.973-7.4,2.347-8.378,3.385-12.826a97.131,97.131,0,0,0,2.751-17,37.3,37.3,0,0,0-.273-8.586c-.492-3.053-1.854-8.6-3.412-8.309-1.421.267-2.448,5.285-2.932,7.655-.837,4.089-.469,5.535-1.213,10.827-.33,2.342-.667,3.94-1.242,6.67-1.157,5.489-2.065,8.292-3.477,13.583-1.821,6.823-1.347,6.044-3.226,13.277-.858,3.3-2.1,7.569-4.553,15.969-1.854,6.353-2.491,8.465-4.575,15.566-2.578,8.784-3.867,13.177-4.231,14.5-5.788,21.034-9.209,34.483-8.9,36.947.255,2.011,2.694,2.058,3.41,2.188C3813.787,716.649,3817.208,715.632,3817.575,713.908Z",
    transform: "translate(-3807.625 -577.813)",
    fill: "#a6c622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M3827.238,651.171c2.264-8.453,3.435-12.741,4.225-16.057,1.729-7.267,1.271-6.476,2.951-13.332,1.3-5.318,2.154-8.14,3.2-13.646.519-2.739.822-4.342,1.1-6.686.633-5.3.233-6.724.985-10.825.436-2.377,1.357-7.409,2.777-7.722,1.244-.274,2.441,3.169,3.158,6.108-.06-.594-.136-1.166-.228-1.731-.492-3.053-1.854-8.6-3.412-8.309-1.421.267-2.448,5.285-2.932,7.655-.837,4.089-.469,5.535-1.213,10.827-.329,2.342-.667,3.94-1.242,6.67-1.157,5.489-2.065,8.292-3.477,13.583-1.821,6.823-1.347,6.044-3.226,13.277-.858,3.3-2.1,7.569-4.553,15.969-1.854,6.353-2.491,8.465-4.575,15.566-2.578,8.784-3.867,13.177-4.231,14.5-5.788,21.034-9.209,34.483-8.9,36.947.255,2.008,6.463,3.169,8.812,1.07C3810.15,710.321,3813.425,702.742,3827.238,651.171Z",
    transform: "translate(-3807.625 -577.813)",
    fill: "#95b71c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(25.383 53.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M4050.582,1086.769c.386-1.574.771-3.166,1.146-4.744.2-.847.4-1.706.6-2.562a.82.82,0,0,0-.5-1.053h0a.877.877,0,0,0-.922.761c-.2.853-.4,1.709-.6,2.553-.374,1.572-.757,3.158-1.142,4.726a.828.828,0,0,0,.485,1.063A.869.869,0,0,0,4050.582,1086.769Z",
    transform: "translate(-4049.132 -1078.4)",
    fill: "#bad32a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(11.735 66.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M3920.741,1249.21c1.783-9.09,3.692-17.558,5.676-25.182.136-.524.3-1.162.508-1.94.473-1.8,1.121-4.273,2.041-7.826,1.271-4.911,2.53-9.847,3.747-14.686a.83.83,0,0,0-.479-1.068.865.865,0,0,0-.933.738c-1.216,4.834-2.474,9.765-3.743,14.67-.918,3.549-1.566,6.016-2.039,7.818-.2.78-.372,1.419-.509,1.945-2,7.671-3.917,16.187-5.709,25.326a.8.8,0,0,0,.543,1.016h0A.9.9,0,0,0,3920.741,1249.21Z",
    transform: "translate(-3919.278 -1198.494)",
    fill: "#bad32a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M3853.541,1657.242c-.163-2.181.606-3.677.256-3.859-.4-.208-1.143,1.889-3.27,3.982-1.7,1.668-3.008,2.092-3.052,3.072-.027.617.469,1.017.985,1.433a5.03,5.03,0,0,0,4.2.689c1.109-.166,1.664-.249,1.907-.71C3855.068,1660.9,3853.735,1659.845,3853.541,1657.242Z",
    transform: "translate(-3843.287 -1539.303)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M3853.541,1657.242c-.163-2.181.606-3.677.256-3.859-.4-.208-1.143,1.889-3.27,3.982-1.7,1.668-3.008,2.092-3.052,3.072-.027.617.469,1.017.985,1.433a5.03,5.03,0,0,0,4.2.689c1.109-.166,1.664-.249,1.907-.71C3855.068,1660.9,3853.735,1659.845,3853.541,1657.242Z",
    transform: "translate(-3843.287 -1539.303)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M3851.037,1662.27c-.6-.232-1.177-.455-1.272-1.042-.151-.931,1.08-1.73,2.445-3.811a17.965,17.965,0,0,0,1.552-2.968c.117-.6.2-.979.036-1.064-.4-.208-1.143,1.889-3.27,3.982-1.7,1.668-3.008,2.092-3.052,3.072-.027.617.469,1.017.985,1.433a5.03,5.03,0,0,0,4.2.689,3.4,3.4,0,0,0,1.753-.505A4.53,4.53,0,0,1,3851.037,1662.27Z",
    transform: "translate(-3843.287 -1539.303)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M3898.3,1406.662c.011-.489-.619-.361-1.208-1.215a6.433,6.433,0,0,1-.7-3.5c-.02-.926.076-1.051.043-2.255s-.06-2.146-.288-2.175c-.267-.033-.595,1.2-1.678,4.246-1.115,3.138-1.616,4.22-1.28,5.374a2.227,2.227,0,0,0,.877,1.3,1.728,1.728,0,0,0,1.25.144C3896.583,1408.365,3898.279,1407.46,3898.3,1406.662Z",
    transform: "translate(-3884.104 -1310.338)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M3898.3,1406.662c.011-.489-.619-.361-1.208-1.215a6.433,6.433,0,0,1-.7-3.5c-.02-.926.076-1.051.043-2.255s-.06-2.146-.288-2.175c-.267-.033-.595,1.2-1.678,4.246-1.115,3.138-1.616,4.22-1.28,5.374a2.227,2.227,0,0,0,.877,1.3,1.728,1.728,0,0,0,1.25.144C3896.583,1408.365,3898.279,1407.46,3898.3,1406.662Z",
    transform: "translate(-3884.104 -1310.338)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M3895.644,1408.1a2.054,2.054,0,0,1-1.006-1.142c-.447-1.081-.042-2.211.789-5.44.448-1.741.713-2.9.908-3.589-.04-.252-.1-.4-.188-.415-.267-.033-.595,1.2-1.678,4.246-1.115,3.138-1.616,4.22-1.28,5.374a2.227,2.227,0,0,0,.877,1.3,1.728,1.728,0,0,0,1.25.144,5.76,5.76,0,0,0,1.465-.472A1.675,1.675,0,0,1,3895.644,1408.1Z",
    transform: "translate(-3884.104 -1310.338)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M3964.8,1441.491c.548-2.366,1.192-3.677,1-3.795s-.752,1.4-2.35,3.023c-.933.946-1.5,1.2-2.023,2.249a3.112,3.112,0,0,0-.425,2.022,1.762,1.762,0,0,0,2.755.674C3964.411,1445.072,3964.178,1444.181,3964.8,1441.491Z",
    transform: "translate(-3944.832 -1346.291)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M3963.961,1445.429a1.659,1.659,0,0,1-1.685-1.078,3.11,3.11,0,0,1,.425-2.022c.519-1.053,1.09-1.3,2.023-2.249.246-.25.467-.5.666-.736.316-1.011.533-1.573.41-1.648-.2-.124-.752,1.4-2.35,3.023-.933.946-1.5,1.2-2.023,2.249a3.112,3.112,0,0,0-.425,2.022,1.762,1.762,0,0,0,2.755.674A1.255,1.255,0,0,0,3963.961,1445.429Z",
    transform: "translate(-3944.832 -1346.291)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M3979.271,1241.074c.236-1.75.692-2.628.449-2.8-.356-.257-1.327,1.634-3.5,3.507-1.921,1.657-3.074,1.826-3.114,2.556-.062,1.133,2.663,1.708,3.222,1.825,1.3.274,2.143.452,2.642-.155C3979.64,1245.193,3978.88,1243.971,3979.271,1241.074Z",
    transform: "translate(-3955.716 -1167.81)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M3974.612,1244.375c.04-.73,1.192-.9,3.114-2.556a17.669,17.669,0,0,0,1.71-1.7c.229-1.117.479-1.7.285-1.844-.356-.257-1.327,1.634-3.5,3.507-1.921,1.657-3.074,1.826-3.114,2.556-.062,1.133,2.663,1.708,3.222,1.825a4.629,4.629,0,0,0,2.161.176c-.205-.039-.424-.085-.659-.135C3977.274,1246.083,3974.55,1245.508,3974.612,1244.375Z",
    transform: "translate(-3955.716 -1167.81)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M4018.744,1067.123c.178-.717-.859-.966-1.178-2.488a20.193,20.193,0,0,1,.021-2.658c-.045-1.247-.084-2.346-.436-2.424-.229-.051-.539.34-2.534,4.537-1.022,2.149-1.2,2.589-1.071,3.078.321,1.24,2.2,1.269,3.148,1.109C4016.944,1068.235,4018.534,1067.967,4018.744,1067.123Z",
    transform: "translate(-3991.871 -1007.894)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M4018.744,1067.123a.621.621,0,0,0-.029-.4,5.471,5.471,0,0,1-1.009.264c-.948.16-2.827.132-3.148-1.109-.127-.489.05-.929,1.071-3.078.723-1.521,1.225-2.542,1.582-3.223a.188.188,0,0,0-.061-.025c-.229-.051-.539.34-2.534,4.537-1.022,2.149-1.2,2.589-1.071,3.078.321,1.24,2.2,1.269,3.148,1.109C4016.944,1068.235,4018.534,1067.967,4018.744,1067.123Z",
    transform: "translate(-3991.871 -1007.894)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M4080.575,1005.05c.371-1.034.776-1.58.642-1.749-.224-.28-1.6.929-2.542,1.968-1.2,1.32-2.353,2.587-2.15,3.586.243,1.2,2.376,1.675,3.194.73C4080.412,1008.785,4079.7,1007.5,4080.575,1005.05Z",
    transform: "translate(-4048.242 -957.521)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M4079.789,1009.5a1.978,1.978,0,0,1-2.232-1.21c-.2-1,.95-2.266,2.151-3.586a15.518,15.518,0,0,1,1.474-1.423c-.3-.151-1.6,1-2.507,1.994-1.2,1.32-2.353,2.587-2.15,3.586.243,1.2,2.376,1.675,3.194.73A1.149,1.149,0,0,0,4079.789,1009.5Z",
    transform: "translate(-4048.242 -957.529)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M4031.34,949.665c-.4-3.312-.531-3.606-.669-3.592-.261.026-.3,1.137-.917,2.836-1.033,2.835-2.338,3.6-2.1,4.593.233.953,1.645,1.125,2.407,1.045a1.633,1.633,0,0,0,1.216-.46C4031.718,953.581,4031.711,952.778,4031.34,949.665Z",
    transform: "translate(-4004.507 -906.344)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M4031.477,953.769c-.083.011-.17.02-.26.029-.762.08-2.174-.092-2.407-1.045-.243-.994,1.062-1.758,2.095-4.593.065-.177.122-.346.175-.51-.206-1.427-.307-1.586-.409-1.576-.261.026-.3,1.137-.917,2.836-1.033,2.835-2.338,3.6-2.1,4.593.233.953,1.645,1.125,2.407,1.045a1.634,1.634,0,0,0,1.216-.46A1.125,1.125,0,0,0,4031.477,953.769Z",
    transform: "translate(-4004.507 -906.344)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M4075.236,894.579c-.1-2.246.469-3.673.159-3.794-.269-.1-.682.974-1.778,2.434-1.759,2.344-2.893,2.493-2.96,3.5-.082,1.215,1.484,2.336,2.913,2.309a2.12,2.12,0,0,0,1.867-.823C4075.9,897.407,4075.33,896.652,4075.236,894.579Z",
    transform: "translate(-4043.009 -856.861)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M4074.941,898.341c-1.429.027-2.995-1.094-2.913-2.309.068-1.005,1.2-1.154,2.961-3.5.141-.188.272-.371.391-.545.1-.715.179-1.14.016-1.2-.269-.1-.682.974-1.778,2.434-1.759,2.344-2.893,2.493-2.96,3.5-.082,1.215,1.484,2.336,2.913,2.309a2.211,2.211,0,0,0,1.793-.71C4075.189,898.336,4075.041,898.339,4074.941,898.341Z",
    transform: "translate(-4043.009 -856.861)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M4074.31,836.82a31.019,31.019,0,0,0-.805-3.64c-.287-1.219-.345-1.569-.489-1.554-.219.023-.364.873-.866,3.15-.667,3.026-.835,3.445-.588,3.939a1.723,1.723,0,0,0,2.7.36C4074.531,838.7,4074.461,838.069,4074.31,836.82Z",
    transform: "translate(-4043.725 -803.925)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M4074.423,838.645a1.775,1.775,0,0,1-1.838-.844c-.248-.495-.08-.914.587-3.939.09-.407.168-.767.237-1.086-.208-.893-.268-1.163-.394-1.15-.219.023-.364.873-.866,3.15-.667,3.026-.835,3.445-.588,3.939a1.723,1.723,0,0,0,2.7.36A.967.967,0,0,0,4074.423,838.645Z",
    transform: "translate(-4043.725 -803.925)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M4107.947,799.938c.374-2.137.436-4.79-.033-4.849-.531-.067-.7,3.32-3.044,5.641-.6.594-1.309,1.084-1.344,1.8-.039.824.845,1.406,1.094,1.57a1.64,1.64,0,0,0,1.4.393C4107.224,804.069,4107.73,801.176,4107.947,799.938Z",
    transform: "translate(-4072.425 -771.228)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M4105.125,803c-.069-.693.574-1.321,1.093-2.025a12.459,12.459,0,0,0,1.94-5.447c-.054-.262-.135-.422-.246-.436-.531-.067-.7,3.32-3.044,5.641-.6.594-1.309,1.084-1.344,1.8-.039.823.845,1.406,1.094,1.57a1.64,1.64,0,0,0,1.4.393,1.18,1.18,0,0,0,.4-.244C4106.093,804.125,4105.2,803.76,4105.125,803Z",
    transform: "translate(-4072.425 -771.228)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M4121.889,860.791c.156-3.422.689-5.4.438-5.44s-.422,2.231-1.926,3.6c-.447.407-.891.621-1.117,1.252a2.494,2.494,0,0,0,.1,1.745c.435.988,1.567,1.492,2.114,1.008C4121.859,862.632,4121.835,861.981,4121.889,860.791Z",
    transform: "translate(-4086.422 -825.157)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M4120.128,861.891a2.494,2.494,0,0,1-.1-1.745c.226-.631.669-.845,1.116-1.252a4.8,4.8,0,0,0,1.022-1.377c.168-1.378.312-2.138.157-2.165-.265-.047-.422,2.231-1.926,3.6-.447.407-.891.621-1.117,1.252a2.494,2.494,0,0,0,.1,1.745c.407.925,1.425,1.425,2,1.089A2.056,2.056,0,0,1,4120.128,861.891Z",
    transform: "translate(-4086.422 -825.157)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M4095.041,767.336c.17-.9-.4-1.383-.777-2.314-.873-2.136.07-4.569-.233-4.623-.25-.045-.541,1.677-1.828,4.555a5.3,5.3,0,0,0-.764,2.364c.027,1.043.618,2.216,1.465,2.227a2.037,2.037,0,0,0,1.321-.785A2.992,2.992,0,0,0,4095.041,767.336Z",
    transform: "translate(-4061.608 -740.184)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M4095.041,767.336c.17-.9-.4-1.383-.777-2.314-.873-2.136.07-4.569-.233-4.623-.25-.045-.541,1.677-1.828,4.555a5.3,5.3,0,0,0-.764,2.364c.027,1.043.618,2.216,1.465,2.227a2.037,2.037,0,0,0,1.321-.785A2.992,2.992,0,0,0,4095.041,767.336Z",
    transform: "translate(-4061.608 -740.184)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M4093.64,768.962c-.848-.011-1.438-1.184-1.466-2.227a5.3,5.3,0,0,1,.764-2.363c.436-.975.758-1.818,1-2.5.09-.849.239-1.443.09-1.469-.25-.045-.541,1.677-1.828,4.555a5.3,5.3,0,0,0-.764,2.364c.027,1.043.618,2.216,1.465,2.227a1.9,1.9,0,0,0,1.25-.71A1.13,1.13,0,0,1,4093.64,768.962Z",
    transform: "translate(-4061.608 -740.184)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M4122.061,723.708a10.947,10.947,0,0,0,.2-2.5c-.062-1.02-.306-5-.9-4.923-.136.017-.239.243-1.062,3.443-.692,2.69-.824,3.327-.687,4.168.155.948.639,2.073,1.184,2,.251-.035.458-.317.64-.565A3.838,3.838,0,0,0,4122.061,723.708Z",
    transform: "translate(-4086.777 -700.708)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M4122.061,723.708a10.947,10.947,0,0,0,.2-2.5c-.062-1.02-.306-5-.9-4.923-.136.017-.239.243-1.062,3.443-.692,2.69-.824,3.327-.687,4.168.155.948.639,2.073,1.184,2,.251-.035.458-.317.64-.565A3.838,3.838,0,0,0,4122.061,723.708Z",
    transform: "translate(-4086.777 -700.708)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M4121.5,725.236a.429.429,0,0,1-.107.031c-.546.077-1.029-1.048-1.184-2-.137-.841-.005-1.478.687-4.168.335-1.3.551-2.113.7-2.617-.072-.137-.15-.21-.235-.2-.136.017-.239.243-1.062,3.443-.692,2.69-.824,3.327-.687,4.168.155.948.639,2.073,1.184,2,.251-.035.458-.317.64-.565C4121.458,725.3,4121.479,725.268,4121.5,725.236Z",
    transform: "translate(-4086.777 -700.708)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M4093.986,700.188a4.809,4.809,0,0,0,.063-1.294,17.846,17.846,0,0,0-.381-2.438c-.274-1.4-.272-1.4-.31-1.557-.158-.638-.568-2.122-.762-2.045-.13.052-.034.758-.09,2.008-.087,1.945-.412,2.292-.409,3.936,0,.992.016,2.172.609,2.518a.742.742,0,0,0,.826-.038A1.8,1.8,0,0,0,4093.986,700.188Z",
    transform: "translate(-4062.198 -679.737)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M4093.876,700.681a.785.785,0,0,1-.589-.08c-.593-.346-.607-1.526-.609-2.518,0-1.644.321-1.992.409-3.936,0-.071.006-.139.008-.206-.175-.579-.379-1.133-.5-1.085s-.034.757-.09,2.008c-.087,1.945-.412,2.292-.409,3.936,0,.992.016,2.172.609,2.518a.742.742,0,0,0,.826-.038A1.134,1.134,0,0,0,4093.876,700.681Z",
    transform: "translate(-4062.198 -679.738)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M4152.813,761.456c.129-1.444.168-1.776.033-1.831-.352-.144-1.615,1.685-1.9,3.675-.1.7.037.61-.018,2.1-.075,2.031-.363,3.08-.115,3.184.219.092.7-.617.968-1.107C4152.448,766.27,4152.47,765.286,4152.813,761.456Z",
    transform: "translate(-4114.655 -739.485)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M4151.62,765.476c.055-1.49-.083-1.4.019-2.1a7.509,7.509,0,0,1,1.281-3.185c.025-.4.006-.533-.074-.566-.352-.144-1.615,1.685-1.9,3.675-.1.7.037.61-.018,2.1-.075,2.031-.363,3.08-.115,3.184.138.058.378-.2.605-.525C4151.457,767.538,4151.576,766.679,4151.62,765.476Z",
    transform: "translate(-4114.655 -739.485)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M4143.129,679.74c.052-1.988-.4-4.035-.847-3.984-.272.031-.528.835-.877,1.929a6,6,0,0,0-.4,1.7c-.028,1.032.436,1.266.739,2.432a15.855,15.855,0,0,1,.175,2.76C4142.16,684.609,4143.062,682.311,4143.129,679.74Z",
    transform: "translate(-4105.967 -664.437)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M4142.6,683.109a6.251,6.251,0,0,0-.173-1.961c-.3-1.166-.767-1.4-.739-2.432a6,6,0,0,1,.4-1.7c.142-.446.269-.842.388-1.159a.228.228,0,0,0-.189-.1c-.272.031-.528.835-.877,1.929a6,6,0,0,0-.4,1.7c-.028,1.032.436,1.266.739,2.432a15.856,15.856,0,0,1,.175,2.76C4142.041,684.594,4142.331,684.016,4142.6,683.109Z",
    transform: "translate(-4105.967 -664.437)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M4109.834,662.917c.472-1.449.468-1.424.478-1.477.222-1.246-.2-1.647-.633-4.172-.19-1.1-.189-1.492-.375-1.514-.437-.052-1.165,2.022-1.48,3.164a6.2,6.2,0,0,0-.337,1.987,8.232,8.232,0,0,0,.64,2.265c.486,1.649.394,2.605.635,2.593C4108.922,665.756,4109.051,665.323,4109.834,662.917Z",
    transform: "translate(-4075.968 -646.537)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M4109.25,664.7a13.537,13.537,0,0,0-.41-1.921,8.231,8.231,0,0,1-.64-2.266,6.218,6.218,0,0,1,.337-1.987,15.537,15.537,0,0,1,.927-2.534c-.039-.159-.084-.232-.161-.241-.437-.052-1.165,2.022-1.48,3.164a6.2,6.2,0,0,0-.337,1.987,8.232,8.232,0,0,0,.64,2.265c.486,1.649.394,2.605.635,2.593C4108.869,665.758,4108.963,665.56,4109.25,664.7Z",
    transform: "translate(-4075.968 -646.537)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M4148.347,715.49c.715-.934.986-.875,1.238-1.472.677-1.6-.472-3.941-.748-3.817-.116.052.012.5-.094,1.547-.1,1.016-.318,1.537-1.334,4.6a11.33,11.33,0,0,0-.546,1.848A14.264,14.264,0,0,1,4148.347,715.49Z",
    transform: "translate(-4111.203 -695.257)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M4147.975,716.017a18.891,18.891,0,0,0,1.177-4.126,10.429,10.429,0,0,0,.042-1.324c-.146-.256-.282-.4-.356-.366-.116.052.013.5-.093,1.547-.1,1.016-.319,1.537-1.334,4.6a11.222,11.222,0,0,0-.546,1.848A19.488,19.488,0,0,1,4147.975,716.017Z",
    transform: "translate(-4111.203 -695.258)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M4133.518,634.415c.077-.232.127-.384.153-.473.486-1.664-.734-4.46-1.33-4.22-.45.182-.482,2.075-.494,2.787-.036,2.1.476,4.061.846,3.984C4132.841,636.464,4133.067,635.781,4133.518,634.415Z",
    transform: "translate(-4097.77 -623.23)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M4133.063,635.769a8.428,8.428,0,0,1-.665-3.877,12.867,12.867,0,0,1,.167-2.133.256.256,0,0,0-.223-.031c-.45.182-.482,2.075-.494,2.787-.036,2.1.476,4.06.846,3.984C4132.78,636.481,4132.893,636.238,4133.063,635.769Z",
    transform: "translate(-4097.77 -623.235)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M4102.609,618.006a4.86,4.86,0,0,0,.66-1.413,4.248,4.248,0,0,0-.275-2.137c-.331-1.126-.516-1.758-.766-1.718-.523.085-.992,3.061-1.042,5.424-.031,1.454.09,2.954.319,2.942S4101.713,619.744,4102.609,618.006Z",
    transform: "translate(-4070.329 -608.042)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M4101.932,619.718a15.045,15.045,0,0,1-.116-2.44,21.271,21.271,0,0,1,.548-4.493.161.161,0,0,0-.135-.047c-.523.085-.992,3.061-1.042,5.424-.031,1.454.09,2.954.319,2.942C4101.643,621.1,4101.689,620.555,4101.932,619.718Z",
    transform: "translate(-4070.329 -608.042)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M4158.435,649.926c.016-.915.034-2.047-.366-2.169-.446-.137-1.374.99-1.391,1.945-.011.611.359.681.694,1.626.427,1.2.211,2.168.366,2.169C4157.946,653.5,4158.4,651.75,4158.435,649.926Z",
    transform: "translate(-4119.991 -639.371)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M4158.214,652.09a4.944,4.944,0,0,0-.235-.979c-.335-.945-.706-1.016-.694-1.626a2.634,2.634,0,0,1,.829-1.707.221.221,0,0,0-.046-.02c-.446-.137-1.374.99-1.391,1.945-.011.611.359.681.694,1.626.427,1.2.211,2.168.366,2.169C4157.857,653.5,4158.058,652.924,4158.214,652.09Z",
    transform: "translate(-4119.991 -639.371)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M4151.023,603.264a14.483,14.483,0,0,0-.862-3.123c-.084-.217-.358-.144-.409.11-.083.417-.193.956-.3,1.471a4.66,4.66,0,0,0-.435,1.624c.009.63.117,2.411.628,2.459C4150.1,605.848,4151.188,604.459,4151.023,603.264Z",
    transform: "translate(-4113.134 -596.656)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M4150.306,605.327c-.511-.047-.62-1.829-.628-2.459a4.649,4.649,0,0,1,.435-1.624c.057-.266.114-.538.167-.8-.041-.11-.08-.213-.117-.307-.084-.217-.358-.144-.409.11-.083.417-.193.956-.3,1.471a4.66,4.66,0,0,0-.435,1.624c.009.63.117,2.411.628,2.459.172.016.435-.173.687-.479Z",
    transform: "translate(-4113.134 -596.656)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M4115.561,586.739a3.691,3.691,0,0,0-.38-2.438c-.539-1.126-.207-2.231-.484-2.276s-.926.993-1.026,2.074c-.122,1.321,1.367,4.021,1.665,3.811C4115.465,587.818,4115.278,587.372,4115.561,586.739Z",
    transform: "translate(-4081.498 -580.557)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M4115.473,586.98a6.861,6.861,0,0,1-1.247-3.468,3.968,3.968,0,0,1,.46-1.482c-.28-.022-.918,1-1.017,2.074-.122,1.321,1.367,4.021,1.665,3.811C4115.448,587.835,4115.321,587.487,4115.473,586.98Z",
    transform: "translate(-4081.498 -580.562)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M4130.833,569.979c-.1-.661-.279-1.777-.91-1.9a1.242,1.242,0,0,0-1.146.715c-.08.143-.369.716.115,2.475.2.743.816,2.971,1.384,2.791C4130.81,573.892,4131.1,571.669,4130.833,569.979Z",
    transform: "translate(-4094.883 -568.068)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M4130.689,574.415c-.5-.295-1-2.1-1.182-2.76-.463-1.685-.218-2.281-.126-2.455a1.578,1.578,0,0,0-.6.607c-.08.143-.369.716.115,2.475.2.743.816,2.971,1.384,2.791C4130.44,575.023,4130.581,574.778,4130.689,574.415Z",
    transform: "translate(-4094.883 -569.082)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M4083.508,769.768c.335-.606.644-.872.641-1.354,0-.259-.092-.39-.482-1.025-.7-1.134-.729-1.239-.828-1.213-.388.1-.629,1.91-.621,3.335.007,1.386.252,2.775.487,2.738C4082.917,772.217,4082.78,771.085,4083.508,769.768Z",
    transform: "translate(-4053.358 -745.352)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M4082.962,771.244a10.388,10.388,0,0,1-.243-2.3,11.909,11.909,0,0,1,.266-2.665c-.074-.1-.1-.118-.146-.107-.388.1-.629,1.91-.621,3.335.007,1.386.252,2.775.487,2.738C4082.829,772.231,4082.834,771.834,4082.962,771.244Z",
    transform: "translate(-4053.358 -745.352)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M3895.682,1700.062c-.564-1.109-.365-2.166-.522-2.158-.221.01-.969,2.135-.272,2.964.4.478,1.2.43,1.318.168C3896.286,1700.849,3895.979,1700.645,3895.682,1700.062Z",
    transform: "translate(-3885.456 -1579.157)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M3918.452,1461.483c.019-.348-.95-.2-1.4-1.086a3.235,3.235,0,0,1-.186-1.546c-.088,0-.774,2.688.013,3.262C3917.4,1462.5,3918.433,1461.838,3918.452,1461.483Z",
    transform: "translate(-3905.059 -1365.229)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M3983.418,1477.9a7.108,7.108,0,0,0,.326-1.794c-.187-.115-1.1.859-1.106,1.848,0,.536.258,1.057.436,1.009C3983.172,1478.935,3983.229,1478.742,3983.418,1477.9Z",
    transform: "translate(-3964.245 -1380.66)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M4017.205,1277.725c.076-.566.085-.891.085-.891a5.273,5.273,0,0,0-.051-1.729c-.106,0-.112.847-.631,1.95-.3.636-.543.878-.473,1.149a.569.569,0,0,0,.886.246C4017.067,1278.4,4017.126,1278.315,4017.205,1277.725Z",
    transform: "translate(-3994.21 -1200.795)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M4039.522,1079.806a6.879,6.879,0,0,1,.044-1.235,8.855,8.855,0,0,0,.117-1.933,3.283,3.283,0,0,0-.791,2.288,3,3,0,0,0,1.206,2.4A3.374,3.374,0,0,1,4039.522,1079.806Z",
    transform: "translate(-4014.585 -1023.186)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M4100.409,1021.876c.21-1.109.557-1.625.489-1.67a3.615,3.615,0,0,0-1.274,2.842c.089.385.356.71.5.638C4100.314,1023.6,4100.206,1022.947,4100.409,1021.876Z",
    transform: "translate(-4068.903 -972.683)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M4055.034,982.36c.194-1.237,0-2.618-.278-2.6-.219.015-.492.92-.535,1.654-.059.988.282,1.945.507,1.89C4054.892,983.265,4054.982,982.688,4055.034,982.36Z",
    transform: "translate(-4028.298 -936.492)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M4103.93,922.693c-.028-.794.173-1.259.108-1.278-.127-.038-1.1,1.754-.658,2.664.217.442.737.608.875.44C4104.413,924.324,4103.97,923.8,4103.93,922.693Z",
    transform: "translate(-4072.192 -884.277)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M4136.719,894.682c.138-.69.319-2.019.11-2.067-.162-.038-.562.685-.66,1.413-.1.758.124,1.51.283,1.482C4136.559,895.491,4136.631,895.122,4136.719,894.682Z",
    transform: "translate(-4101.615 -858.504)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M4089.331,866.378c-.074-.8-.126-1.352-.246-1.345-.151.009-.445.9-.319,1.7.1.61.434,1.118.564,1.046S4089.4,867.113,4089.331,866.378Z",
    transform: "translate(-4059.19 -833.822)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M4131.3,842.567c.017-.045.045-.125.08-.231a4.773,4.773,0,0,0,.356-1.59c-.1-.054-.61.741-.938,1.644a3.894,3.894,0,0,0-.345,1.853C4130.577,844.286,4131.04,843.284,4131.3,842.567Z",
    transform: "translate(-4096.489 -812.085)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M4161.819,790.621a7.209,7.209,0,0,0,.167-2.245c-.088-.013-.271.552-.342.8a3.986,3.986,0,0,0-.058,2.48C4161.647,791.651,4161.7,791.308,4161.819,790.621Z",
    transform: "translate(-4124.246 -765.222)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M4112.432,803.111a1.783,1.783,0,0,0-.047-.856c-.116-.439-.263-.46-.462-.928-.245-.574-.229-1.027-.283-1.013a2.491,2.491,0,0,0,0,1.357c.118.509.259.5.338.958.125.712-.127,1.259-.021,1.3S4112.338,803.562,4112.432,803.111Z",
    transform: "translate(-4079.611 -775.905)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M4091.511,781.918c.063-.375-.233-.747-.307-.7-.05.031.028.237.017.6a3.514,3.514,0,0,1-.372,1.325c.011.006.1.192.406-.415A2.228,2.228,0,0,0,4091.511,781.918Z",
    transform: "translate(-4061.081 -758.812)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M4136.644,751.947c.046-.894,0-2.09-.166-2.082a4.846,4.846,0,0,0-.462,2.256c-.036.943.092,1.979.243,1.961A5.342,5.342,0,0,0,4136.644,751.947Z",
    transform: "translate(-4101.497 -730.758)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M4153.518,696.495c-.02-1.212-.041-1.362-.093-1.365-.116-.007-.386.707-.424,1.43-.052,1,.352,1.856.486,1.8A8.957,8.957,0,0,0,4153.518,696.495Z",
    transform: "translate(-4116.697 -681.775)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M4125.976,688.788a4.43,4.43,0,0,0,.038-.826c-.035-.647-.236-1.4-.36-1.361a8.932,8.932,0,0,0-.068,3.629A3.574,3.574,0,0,0,4125.976,688.788Z",
    transform: "translate(-4092.029 -674.143)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M4142.983,648.9c-.033-.61-.255-1.258-.369-1.216a5.759,5.759,0,0,0,.067,2.739A2.506,2.506,0,0,0,4142.983,648.9Z",
    transform: "translate(-4107.287 -639.317)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M4144.061,580.124c-.108-.434-.31-.924-.4-.882s-.041.745.013,1.14c.092.673.314,1.529.435,1.486A3.128,3.128,0,0,0,4144.061,580.124Z",
    transform: "translate(-4108.293 -578.066)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M4161.5,624.884c.044-.481-.07-1.015-.173-1a4.119,4.119,0,0,0-.269,2.127C4161.161,626.036,4161.447,625.46,4161.5,624.884Z",
    transform: "translate(-4123.855 -618.019)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M4167,655.7c-.082-.934-.047-1.273-.121-1.277-.1,0-.318.537-.31,1.076.011.694.406,1.223.5,1.163C4167.116,656.63,4167.06,656.437,4167,655.7Z",
    transform: "translate(-4128.84 -645.348)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M4113.184,638.215c.051-.393.047-.948-.036-.95a6.115,6.115,0,0,0-.554,2.421A2.515,2.515,0,0,0,4113.184,638.215Z",
    transform: "translate(-4080.515 -629.992)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M4103.679,735.077a5.007,5.007,0,0,0-.164-1.736,3.005,3.005,0,0,0-.238,1.446c.008.759.2,1.466.3,1.438S4103.676,735.44,4103.679,735.077Z",
    transform: "translate(-4072.203 -715.971)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M4167.366,732.638c.058-.341.011-.769-.093-.773a2.9,2.9,0,0,0-.525,1.74C4166.851,733.666,4167.269,733.211,4167.366,732.638Z",
    transform: "translate(-4128.973 -714.65)",
    fill: "#dbf279"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(0 2.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M3789.107,676.766c.814-2.151,3.909-13.794,6.629-34.155,1.453-10.876,1.785-8.343,4.483-25.994,1.153-7.547.729-5.628,3.91-28.664.905-6.557,1.494-13.129,2.508-19.679.836-5.4,1.677-10.017,1.328-16.262a47.9,47.9,0,0,0-1.611-9.489c-.525-1.907-2.167-7.879-3.586-7.461-.188.055-.782.344-1.943,6.132a59.471,59.471,0,0,0-1.339,8.619c-.394,5.96.635,7.129.129,13.806-.03.385-.2,1.854-.531,4.79-.322,2.828-.921,8.084-1.346,11.228-.778,5.753-1.375,7.39-2.45,13.348-1.487,8.248-.9,8.194-2.634,20.411-1.11,7.81-2.208,13.861-2.854,17.406-.682,3.737-1.679,9.174-3.245,16.246-1.773,8.01-2.343,16.368-5.182,24.056a6.37,6.37,0,0,0-.442,2.563,5.149,5.149,0,0,0,2.01,3.754C3784.981,678.858,3788.52,678.316,3789.107,676.766Z",
    transform: "translate(-3780.923 -534.496)",
    fill: "#a6c622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M3789.107,676.766c.125-.33.3-.885.527-1.66-1.3.26-5.435.41,5.677-64.752,2.079-12.19,1.147-12.163,2.635-20.411,1.074-5.958,1.672-7.6,2.449-13.348.425-3.143,1.024-8.4,1.346-11.228.334-2.937.5-4.4.531-4.79.506-6.677-.523-7.847-.129-13.806a59.438,59.438,0,0,1,1.339-8.619c.17-.85.329-1.58.475-2.209-.395-.629-.8-1-1.188-.881-.188.055-.782.344-1.943,6.132a59.472,59.472,0,0,0-1.339,8.619c-.394,5.96.635,7.129.129,13.806-.03.385-.2,1.854-.531,4.79-.322,2.828-.921,8.084-1.346,11.227-.778,5.753-1.375,7.39-2.45,13.348-1.487,8.248-.9,8.194-2.634,20.411-1.11,7.81-2.208,13.861-2.854,17.406-.682,3.737-1.679,9.174-3.245,16.246-1.773,8.01-2.343,16.368-5.182,24.056a6.37,6.37,0,0,0-.442,2.563,5.147,5.147,0,0,0,2.01,3.753C3784.981,678.859,3788.52,678.317,3789.107,676.766Z",
    transform: "translate(-3780.923 -534.497)",
    fill: "#95b71c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M3860.216,1388.439c.955-.646,1.562-1.056,1.707-1.621.3-1.17-1.709-1.691-2.5-4.364-.5-1.685-.129-2.943-.375-2.96-.435-.03-1.691,3.859-1.53,7.729.052,1.25.276,3.076.655,3.051.129-.009.193-.227.444-.574A4.86,4.86,0,0,1,3860.216,1388.439Z",
    transform: "translate(-3849.459 -1290.196)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M3860.216,1388.439c.955-.646,1.562-1.056,1.707-1.621a.992.992,0,0,0-.168-.823c-.177.125-.372.257-.586.4a4.858,4.858,0,0,0-1.6,1.261c-.251.348-.314.566-.444.574-.379.025-.6-1.8-.655-3.051a20.116,20.116,0,0,1,.624-5.657.064.064,0,0,0-.048-.029c-.435-.03-1.691,3.859-1.53,7.729.052,1.25.276,3.076.655,3.051.129-.009.193-.227.444-.574A4.86,4.86,0,0,1,3860.216,1388.439Z",
    transform: "translate(-3849.459 -1290.196)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M3913.537,1145.366c-.064-.689-.985-.42-1.567-1.47-.427-.769-.372-1.7-.285-3.2.108-1.862.466-2.962.322-3.01s-.55,1.031-1.812,3.661c-1.007,2.1-1.29,2.54-1.745,2.984-.488.478-.8.589-.915,1.022-.231.857.588,1.866,1.275,2.309a2.682,2.682,0,0,0,2.272.24C3912.3,1147.5,3913.615,1146.215,3913.537,1145.366Z",
    transform: "translate(-3894.191 -1073.802)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M3911.32,1147.812a2.427,2.427,0,0,1-1.1-.378c-.687-.443-1.506-1.452-1.275-2.309.117-.433.426-.544.914-1.022.456-.445.739-.888,1.746-2.984l.066-.139c0-.092.01-.187.016-.284.108-1.862.466-2.962.322-3.01s-.55,1.031-1.812,3.661c-1.007,2.1-1.29,2.54-1.745,2.984-.488.478-.8.589-.915,1.022-.231.857.588,1.866,1.275,2.309a2.682,2.682,0,0,0,2.272.24C3911.161,1147.876,3911.24,1147.846,3911.32,1147.812Z",
    transform: "translate(-3894.191 -1073.802)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M3967.258,1006.183c.541-1.993,1.223-9.377.933-9.407-.067-.007-.147.043-1.419,2.522a19.3,19.3,0,0,1-1.59,2.939c-1.038,1.329-1.8,1.349-1.877,2.038-.107.908,1.111,1.675,1.88,1.938C3965.563,1006.342,3966.993,1007.16,3967.258,1006.183Z",
    transform: "translate(-3944.131 -947.701)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M3966.742,1006.1c-.769-.263-1.988-1.031-1.881-1.938.082-.69.84-.71,1.877-2.039a15.847,15.847,0,0,0,1.4-2.575,9.894,9.894,0,0,0,.049-2.772c-.067-.007-.147.043-1.419,2.522a19.3,19.3,0,0,1-1.59,2.939c-1.038,1.329-1.8,1.349-1.877,2.038-.107.908,1.111,1.675,1.88,1.938.362.124,1.684.877,2.031.086C3967.013,1006.215,3966.841,1006.133,3966.742,1006.1Z",
    transform: "translate(-3944.131 -947.701)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M3910.652,1022.931c.635-1.191-.084-2.335-.394-5.136-.255-2.307,0-3.617-.211-3.626-.241-.011-.467,1.672-1.521,5.68-.685,2.6-.785,3.974-.335,4.46.393.425.954-.062,1.392-.31A2.759,2.759,0,0,0,3910.652,1022.931Z",
    transform: "translate(-3894.569 -963.267)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M3909.8,1023.864c-.3.156-.6.234-.835-.024-.45-.486-.349-1.856.335-4.46.372-1.412.64-2.534.842-3.4-.024-1.169.055-1.809-.093-1.816-.241-.011-.467,1.672-1.521,5.68-.685,2.6-.785,3.974-.335,4.46.393.425.954-.062,1.392-.31C3909.62,1023.976,3909.7,1023.932,3909.8,1023.864Z",
    transform: "translate(-3894.569 -963.267)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M3946.15,931.354c.535-1.03-.818-2.34-1.451-5-.562-2.362-.113-3.929-.449-3.962-.384-.038-.6,2.04-2.177,6.915a3.831,3.831,0,0,0-.238,2.522,1.8,1.8,0,0,0,1.555.972,3.182,3.182,0,0,0,2.005-.782C3945.828,931.713,3946.044,931.559,3946.15,931.354Z",
    transform: "translate(-3924.797 -881.137)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M3944.681,932.4a1.8,1.8,0,0,1-1.555-.972,3.829,3.829,0,0,1,.238-2.522c.488-1.513.846-2.756,1.119-3.75-.209-1.679.042-2.736-.233-2.763-.384-.038-.6,2.04-2.177,6.915a3.831,3.831,0,0,0-.238,2.522,1.8,1.8,0,0,0,1.555.972,2.482,2.482,0,0,0,1.427-.4C3944.772,932.4,3944.727,932.4,3944.681,932.4Z",
    transform: "translate(-3924.797 -881.137)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M3977.656,852.777c-.159-1.608-.55-3.715-.9-3.636-.173.039-.18.582-.5,1.749a9.311,9.311,0,0,1-1.709,3.92c-.565.623-1.063.8-1.182,1.428a1.763,1.763,0,0,0,.208,1.078c.116.272.722,1.686,2.019,1.7a1.847,1.847,0,0,0,1.362-.478C3978.117,857.444,3977.851,854.748,3977.656,852.777Z",
    transform: "translate(-3953.122 -815.582)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M3974.219,857.493c.118-.628.616-.806,1.181-1.429a9.3,9.3,0,0,0,1.709-3.92c.146-.537.227-.941.289-1.225-.185-1.013-.421-1.829-.64-1.779-.173.039-.18.582-.5,1.749a9.311,9.311,0,0,1-1.709,3.92c-.565.623-1.063.8-1.182,1.428a1.763,1.763,0,0,0,.208,1.078,3.486,3.486,0,0,0,.838,1.227A1.721,1.721,0,0,1,3974.219,857.493Z",
    transform: "translate(-3953.122 -815.582)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M4017.61,819.482c.138-1.114.158-1.614-.006-1.678-.28-.11-.985,1.094-1.373,1.968a5.989,5.989,0,0,0-.5,1.5c-.273,1.613.367,3.346.817,3.255S4017.238,822.487,4017.61,819.482Z",
    transform: "translate(-3990.99 -787.534)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M4016.815,824.207a4.47,4.47,0,0,1-.541-3.114,5.986,5.986,0,0,1,.5-1.5,8.983,8.983,0,0,1,.92-1.627c-.019-.09-.05-.143-.1-.161-.28-.11-.985,1.094-1.373,1.968a5.989,5.989,0,0,0-.5,1.5c-.273,1.613.367,3.346.817,3.255C4016.643,824.506,4016.732,824.4,4016.815,824.207Z",
    transform: "translate(-3990.99 -787.534)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M3955.583,816.781c.6-1.319-.869-2.543-1-5.635-.036-.861.052-1.425-.048-1.434-.223-.019-.818,2.792-1.138,4.6-.4,2.253-.695,3.995-.194,4.266.345.187.987-.367,1.463-.778A3.107,3.107,0,0,0,3955.583,816.781Z",
    transform: "translate(-3934.863 -780.299)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M3954.2,814.255c.123-.694.286-1.535.453-2.308-.032-.253-.055-.519-.066-.8-.036-.861.052-1.425-.048-1.434-.223-.019-.818,2.792-1.138,4.6-.4,2.253-.695,3.995-.194,4.266.172.094.42,0,.685-.166C3953.559,817.935,3953.837,816.307,3954.2,814.255Z",
    transform: "translate(-3934.863 -780.299)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M3980.21,748.781c.422-1.306-.342-1.646-.411-3.9-.01-.334.1-1.5.314-3.819.168-1.8.21-2.1.078-2.166-.414-.194-1.992,2.286-2.817,4.921a11.671,11.671,0,0,0-.6,4.037,10.918,10.918,0,0,0,.432,2.344c.392,1.539.64,1.623.752,1.633.128.011.332-.055,1.011-1.012A8.252,8.252,0,0,0,3980.21,748.781Z",
    transform: "translate(-3956.183 -716.92)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M3978.242,749.432a10.9,10.9,0,0,1-.432-2.344,11.673,11.673,0,0,1,.6-4.037,16.759,16.759,0,0,1,1.857-3.991c-.01-.1-.033-.14-.073-.159-.414-.194-1.992,2.286-2.817,4.921a11.671,11.671,0,0,0-.6,4.037,10.918,10.918,0,0,0,.432,2.344c.392,1.539.64,1.623.752,1.633s.307-.047.889-.843A3.706,3.706,0,0,1,3978.242,749.432Z",
    transform: "translate(-3956.183 -716.92)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M4014.465,727.085c.405-.729.416-1.251.508-5.227.021-.923.03-1.288-.155-1.383-.448-.229-1.562,1.362-2.145,2.445a9.59,9.59,0,0,0-1.041,3.183c-.127.911-.244,1.753.163,2.192.459.495,1.278.147,1.412.087A2.957,2.957,0,0,0,4014.465,727.085Z",
    transform: "translate(-3987.278 -700.421)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M4012.762,726.2a9.579,9.579,0,0,1,1.041-3.183,11.73,11.73,0,0,1,1.18-1.785c0-.475-.03-.691-.166-.761-.448-.229-1.562,1.362-2.145,2.445a9.591,9.591,0,0,0-1.041,3.183c-.127.911-.244,1.753.163,2.192a1.145,1.145,0,0,0,1.2.167.752.752,0,0,1-.072-.067C4012.518,727.957,4012.635,727.115,4012.762,726.2Z",
    transform: "translate(-3987.278 -700.421)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M3952.641,723.9c.228-.886-.539-1.276-1.025-2.9-.643-2.15-.1-4.122-.321-4.134-.2-.011-.649,1.638-.906,3.259-.265,1.671-.752,4.748.179,5.238C3951.187,725.684,3952.4,724.849,3952.641,723.9Z",
    transform: "translate(-3932.25 -697.207)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M3951.367,724.933c-.932-.489-.444-3.567-.179-5.238.034-.216.072-.433.112-.646-.057-1.262.147-2.178,0-2.187-.2-.011-.649,1.638-.906,3.259-.265,1.671-.752,4.748.179,5.238a1.351,1.351,0,0,0,1.348-.383A.791.791,0,0,1,3951.367,724.933Z",
    transform: "translate(-3932.25 -697.207)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M3969.711,686.44a4.2,4.2,0,0,0,.307-1.21c.093-1.043-.344-1.274-.46-2.471-.081-.835,0-4.179-.455-4.211-.49-.034-1.231,2.239-1.56,3.625a7.826,7.826,0,0,0-.289,3.387c.21,1.13.847,2.484,1.469,2.329C3969.181,687.775,3969.542,686.866,3969.711,686.44Z",
    transform: "translate(-3947.592 -662.92)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M3967.965,684.85a7.834,7.834,0,0,1,.289-3.387,16.836,16.836,0,0,1,.938-2.859.13.13,0,0,0-.089-.056c-.49-.034-1.231,2.239-1.56,3.625a7.826,7.826,0,0,0-.289,3.387c.21,1.13.847,2.484,1.469,2.329.252-.063.475-.368.653-.7C3968.773,687.251,3968.169,685.945,3967.965,684.85Z",
    transform: "translate(-3947.592 -662.92)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M4022.121,658.306c.413-.723.164-1.336-.068-4.17-.115-1.4-.1-1.876-.264-1.892-.388-.037-1.119,2.685-1.213,3.041-.73,2.75-.985,5.576-.63,5.649.16.033.287-.524,1.037-1.444C4021.687,658.626,4021.853,658.776,4022.121,658.306Z",
    transform: "translate(-3994.682 -639.381)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M4021.359,654.825c.054-.2.313-1.165.6-1.955-.037-.442-.072-.616-.167-.626-.388-.037-1.119,2.685-1.213,3.041-.73,2.75-.985,5.576-.63,5.649.125.026.232-.313.635-.906A20.177,20.177,0,0,1,4021.359,654.825Z",
    transform: "translate(-3994.682 -639.381)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M3998.241,678.4c.138-.232.267-.617-.025-2.426a6.934,6.934,0,0,0-.458-1.912c-.169-.35-.594-1.229-.943-1.094-.571.222-.548,3.015-.43,4.49.042.531.177,2.1.619,2.116.154.005.351-.2.744-.6A3.42,3.42,0,0,0,3998.241,678.4Z",
    transform: "translate(-3973.679 -657.914)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M3998.241,678.4a.953.953,0,0,0,.125-.359l-.2.206c-.393.407-.59.61-.744.6-.442-.014-.577-1.585-.619-2.116a16.717,16.717,0,0,1,.078-3.781.2.2,0,0,0-.067.014c-.571.222-.548,3.015-.43,4.49.042.531.177,2.1.619,2.116.154.005.351-.2.744-.6A3.418,3.418,0,0,0,3998.241,678.4Z",
    transform: "translate(-3973.679 -657.917)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M4006.1,633.423c.181-1.141.2-1.007.221-1.281.051-.8-.2-1.03-.945-3.082-.263-.727-.344-1.011-.471-.982-.147.034-.206.46-.513,2.12-.271,1.466-.321,1.647-.24,1.963.143.561.423.482.912,1.277.5.819.572,1.5.735,1.445C4005.919,634.843,4005.937,634.487,4006.1,633.423Z",
    transform: "translate(-3980.664 -617.753)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M4006.043,633.821a5.075,5.075,0,0,0-.322-.622c-.488-.8-.769-.715-.912-1.277-.08-.316-.031-.5.24-1.963.094-.509.165-.9.223-1.2-.18-.5-.255-.7-.362-.678-.147.034-.206.46-.513,2.12-.271,1.466-.321,1.647-.24,1.963.143.562.423.482.912,1.277.5.819.572,1.5.735,1.445C4005.9,634.849,4005.93,634.578,4006.043,633.821Z",
    transform: "translate(-3980.664 -617.753)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M3953.684,650.771c.389-.823.641-.927.607-1.241-.066-.615-1.049-.349-1.706-1.236-.565-.762-.437-1.767-.586-1.739s-.245,1.172-.432,3.931-.228,3.492.066,3.611c.344.139.973-.625,1.285-1.169C3953.349,652.176,3953.188,651.819,3953.684,650.771Z",
    transform: "translate(-3933.501 -634.29)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M3952.071,650.458c.083-1.226.146-2.132.2-2.763-.208-.6-.165-1.16-.276-1.139-.159.03-.245,1.171-.432,3.931s-.228,3.491.066,3.61a.451.451,0,0,0,.4-.111C3951.857,653.72,3951.909,652.856,3952.071,650.458Z",
    transform: "translate(-3933.501 -634.29)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M4021.878,596.107c.194-.683.049-1.215-.624-3.234-.783-2.354-.92-2.638-1.029-2.594-.17.069-.009.831-.221,2.71a4.993,4.993,0,0,0-.074,1.856c.131.532.31.543.525,1.236.266.858.145,1.337.348,1.4C4021.067,597.57,4021.654,596.893,4021.878,596.107Z",
    transform: "translate(-3994.752 -583.925)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M4021.214,595.518c-.215-.693-.395-.7-.525-1.236a5,5,0,0,1,.074-1.856c.033-.289.056-.552.074-.79-.423-1.223-.526-1.393-.612-1.358-.17.069-.009.831-.221,2.71a4.993,4.993,0,0,0-.074,1.856c.131.532.31.543.525,1.236.266.858.145,1.337.348,1.4.167.054.463-.2.715-.589C4021.377,596.771,4021.458,596.3,4021.214,595.518Z",
    transform: "translate(-3994.752 -583.925)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M3983.972,605.73a7.869,7.869,0,0,0,.089-2.227c-.1-.928-.265-.962-.464-2.161s-.114-1.691-.248-1.7c-.29-.028-.926,2.2-1.172,4.225a4.1,4.1,0,0,0,.2,2.568c.249.449.743.94,1.1.738C3983.763,607.008,3983.851,606.472,3983.972,605.73Z",
    transform: "translate(-3960.949 -592.304)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M3983.608,607.053a2.191,2.191,0,0,1-.418-.535,4.1,4.1,0,0,1-.2-2.568,20.373,20.373,0,0,1,.563-2.864c-.149-1.024-.084-1.435-.208-1.447-.29-.028-.926,2.2-1.172,4.225a4.1,4.1,0,0,0,.2,2.568c.249.449.743.94,1.1.738A.44.44,0,0,0,3983.608,607.053Z",
    transform: "translate(-3960.949 -592.304)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M3959.837,592.639a6.387,6.387,0,0,0,0-1.429,4.457,4.457,0,0,0-.342-1.154,16.042,16.042,0,0,1-.547-3.1,27.347,27.347,0,0,0-1.187,4.6,3.81,3.81,0,0,0,.895,2.517c.249.336.579.782.824.646C3959.7,594.59,3959.749,593.94,3959.837,592.639Z",
    transform: "translate(-3939.172 -580.953)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M3959.71,594.109a3.648,3.648,0,0,1-.44-.524,3.816,3.816,0,0,1-.895-2.518,23.988,23.988,0,0,1,.684-3.039c-.051-.645-.027-1.085-.112-1.075a27.347,27.347,0,0,0-1.187,4.6,3.81,3.81,0,0,0,.895,2.517c.249.336.579.782.824.646C3959.593,594.651,3959.66,594.455,3959.71,594.109Z",
    transform: "translate(-3939.172 -580.953)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M3999.366,556.378a9.15,9.15,0,0,0,.6-2.919c-.036-1.981-1.121-3.478-1.4-3.316-.232.136.257,1.356-.339,2.822-.255.626-.422.6-.6,1.18a3.566,3.566,0,0,0,.245,2.573c.108.2.5.923.9.778C3999,557.417,3999.148,557.1,3999.366,556.378Z",
    transform: "translate(-3974.734 -548)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M3998.633,556.8a3.565,3.565,0,0,1-.245-2.573c.175-.583.343-.553.6-1.18a4.767,4.767,0,0,0,.291-2.2c-.286-.5-.58-.776-.705-.7-.232.136.257,1.356-.339,2.822-.255.626-.422.6-.6,1.18a3.565,3.565,0,0,0,.245,2.573c.108.2.5.923.9.778a.446.446,0,0,0,.2-.17A2.993,2.993,0,0,1,3998.633,556.8Z",
    transform: "translate(-3974.734 -548)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M3973.767,537.221a10.364,10.364,0,0,1,.639-1.424,8.292,8.292,0,0,0,.837-3.142c.014-1.309-.553-2.849-1.191-2.8-.729.059-1.635,2.2-1.672,3.986a24.911,24.911,0,0,0,.445,2.843c.236,1.44.36,2.257.5,2.227C3973.453,538.889,3973.434,538.229,3973.767,537.221Z",
    transform: "translate(-3952.258 -529.857)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M3973.533,538.1c-.041-.247-.086-.523-.136-.829a24.931,24.931,0,0,1-.445-2.843c.037-1.785.943-3.927,1.672-3.986a.4.4,0,0,1,.136.014c-.2-.381-.448-.622-.707-.6-.729.059-1.635,2.2-1.672,3.986a24.91,24.91,0,0,0,.445,2.843c.236,1.44.36,2.257.5,2.228C3973.411,538.9,3973.431,538.6,3973.533,538.1Z",
    transform: "translate(-3952.258 -529.857)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(18.932 61.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M3962.524,1120.506c.164-.878.3-1.762.408-2.64.141-1.15.236-2.31.282-3.46.021-.517-.306-.9-.726-.842h0a1,1,0,0,0-.756.983c-.043,1.09-.133,2.19-.267,3.279-.1.833-.232,1.672-.388,2.505a.8.8,0,0,0,.532,1h0A.9.9,0,0,0,3962.524,1120.506Z",
    transform: "translate(-3961.058 -1113.558)",
    fill: "#bad32a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(10.852 74.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M3885.647,1283.339c.305-1.883.589-3.8.845-5.72.2-1.467.319-2.505.427-3.422.132-1.113.235-1.992.416-3.177.3-1.957.54-3,.939-4.725.192-.832.432-1.867.727-3.225,1.364-6.275,2.165-11.35,2.81-15.428.271-1.716.53-3.447.771-5.156.072-.509-.2-.939-.6-.96h0a.937.937,0,0,0-.857.875c-.24,1.7-.5,3.416-.766,5.121-.64,4.048-1.436,9.086-2.784,15.294-.292,1.343-.519,2.327-.72,3.194-.4,1.72-.66,2.856-.973,4.9-.187,1.224-.293,2.121-.427,3.256-.107.908-.229,1.937-.422,3.387-.253,1.9-.534,3.8-.836,5.658a.778.778,0,0,0,.574.979A.922.922,0,0,0,3885.647,1283.339Z",
    transform: "translate(-3884.177 -1241.524)",
    fill: "#bad32a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M3853.315,1609.581a7.068,7.068,0,0,0,.461-3.244c-.038-2.336-.607-5.077-1.209-4.974-.413.071-.291,1.385-1.3,2.969-1.115,1.751-2.2,1.624-2.508,2.842-.193.772.15,1.559.837,3.133.455,1.041.69,1.563,1.091,1.668C3851.567,1612.206,3852.756,1610.835,3853.315,1609.581Z",
    transform: "translate(-3841.583 -1488.744)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M3851.122,1610.467c-.687-1.574-1.03-2.36-.837-3.133.3-1.218,1.394-1.091,2.508-2.842a6.62,6.62,0,0,0,.644-1.317c-.228-1.093-.543-1.869-.869-1.813-.413.071-.291,1.385-1.3,2.969-1.115,1.751-2.2,1.624-2.508,2.842-.193.772.15,1.559.837,3.133.455,1.041.69,1.563,1.091,1.668a1.262,1.262,0,0,0,1.02-.289A10.314,10.314,0,0,1,3851.122,1610.467Z",
    transform: "translate(-3841.583 -1488.744)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M3935.649,1300.884c.292-2.821.614-2.5,1-6.107.1-.957.318-2.945.119-2.97-.254-.032-.372,3.222-2.248,5.044-.831.807-1.623.96-1.776,1.739-.029.149-.075.522.758,1.882.712,1.162,1.361,2.221,1.773,1.989C3935.535,1302.315,3935.56,1301.751,3935.649,1300.884Z",
    transform: "translate(-3916.78 -1211.725)",
    fill: "#d5e53c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M3935.546,1301.828c-.282-.374-.593-.882-.918-1.412-.833-1.36-.787-1.733-.758-1.882.153-.778.945-.932,1.776-1.739a5.4,5.4,0,0,0,.912-1.2c.032-.25.063-.522.1-.821.1-.957.318-2.945.119-2.97-.254-.032-.372,3.222-2.248,5.044-.831.807-1.623.96-1.776,1.739-.029.149-.075.522.758,1.882.712,1.162,1.361,2.221,1.773,1.989C3935.425,1302.378,3935.5,1302.16,3935.546,1301.828Z",
    transform: "translate(-3916.78 -1211.725)",
    fill: "#ccd32f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M3880.315,1645.559c.3-1.127.243-2.406.048-2.418-.363-.022-1.467,4.3-1.136,4.447C3879.4,1647.664,3880.035,1646.6,3880.315,1645.559Z",
    transform: "translate(-3868.841 -1526.134)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M3873.138,1421.329c.026-.236-.491-.224-1.033-.855-.431-.5-.484-.947-.583-.9-.183.086-.366,1.787.362,2.182A1,1,0,0,0,3873.138,1421.329Z",
    transform: "translate(-3861.853 -1326.061)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M3951.85,1351.624c.1-.867.322-1.234.227-1.312-.131-.106-.774.384-.868,1.044s.4,1.213.547,1.127C3951.84,1352.434,3951.784,1352.2,3951.85,1351.624Z",
    transform: "translate(-3933.301 -1264.068)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M3941.866,1197.5c.013-.183-.4-.129-.791-.549-.524-.564-.458-1.391-.576-1.366-.173.037-.629,1.864.04,2.334A1.041,1.041,0,0,0,3941.866,1197.5Z",
    transform: "translate(-3923.448 -1125.613)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M3969.322,987.674a1.126,1.126,0,0,0-.108-.37c-.071-.155-.262-.5-.392-.441-.027.013-.083.06-.142.592-.067.608-.1.911.025,1.013s.37.027.506-.149A.887.887,0,0,0,3969.322,987.674Z",
    transform: "translate(-3948.892 -938.824)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M3926.153,1079.6c.125-.624-.045-1.289-.212-1.276s-.33.677-.389,1c-.091.5-.114,1.223.053,1.26C3925.755,1080.62,3926.053,1080.1,3926.153,1079.6Z",
    transform: "translate(-3910.288 -1020.679)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M3992.021,1056.113c.149-.891.381-1.23.287-1.325-.136-.138-.874.324-1,1.024-.12.677.385,1.281.558,1.188C3991.961,1056.95,3991.919,1056.717,3992.021,1056.113Z",
    transform: "translate(-3969.181 -999.595)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M3996.953,899.33a2.7,2.7,0,0,0-.173-1.137c-.088.023.3,1.64-.362,2.525-.49.657-1.283.546-1.342.93-.035.231.219.479.465.515.5.074.958-.733,1.036-.869A3.713,3.713,0,0,0,3996.953,899.33Z",
    transform: "translate(-3972.566 -859.48)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M3968.547,857.856c.016-.58-.227-1.1-.334-1.06-.09.034-.023.441-.141,1.243a13.476,13.476,0,0,0-.3,1.506c.077.042.334-.352.481-.648A2.468,2.468,0,0,0,3968.547,857.856Z",
    transform: "translate(-3948.122 -822.432)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M3997.944,802.988a3.767,3.767,0,0,0,.467-1.209c.036-.379-.094-.439-.253-1.1-.229-.942-.133-1.516-.255-1.518s-.376.626-.4,1.262c-.024.578.155.675.222,1.282a10.124,10.124,0,0,1-.194,1.983C3997.59,803.712,3997.742,803.4,3997.944,802.988Z",
    transform: "translate(-3974.736 -770.859)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M4029.977,757.626a4.035,4.035,0,0,0,.407-1.075c.112-.544.108-1.2-.012-1.213s-.351.658-.623,1.472a5.844,5.844,0,0,0-.461,1.815C4029.39,758.681,4029.783,758.007,4029.977,757.626Z",
    transform: "translate(-4003.162 -731.64)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M4033.85,688.76a2.626,2.626,0,0,0,.1-.782c.008-.444-.05-1.049-.152-1.041-.036,0-.088.083-.322,1.224-.295,1.438-.252,1.5-.224,1.514C4033.357,689.727,4033.7,689.26,4033.85,688.76Z",
    transform: "translate(-4006.711 -670.428)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M3985.533,723.283a6.439,6.439,0,0,0-.306-1.011c-.168-.623-.152-.962-.2-.954a4.891,4.891,0,0,0-.122,1.991c.021.226.112,1.262.3,1.243C3985.353,724.538,3985.584,723.872,3985.533,723.283Z",
    transform: "translate(-3963.435 -701.196)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M4006.714,694.8c-.165-1.014-.188-1.246-.23-1.236-.067.016-.01.608-.139,1.663-.105.86-.244,1.275-.092,1.388.123.091.39-.05.526-.271C4006.936,696.093,4006.876,695.81,4006.714,694.8Z",
    transform: "translate(-3982.51 -676.359)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M3965.406,768.625a1.792,1.792,0,0,0,.01-.7c-.079-.491-.345-1-.466-.935-.226.114-.029,2.231.209,2.212C3965.264,769.2,3965.375,768.77,3965.406,768.625Z",
    transform: "translate(-3945.519 -742.065)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M3963.934,674.622c.176-.35.336-.572.287-.808a.419.419,0,0,0-.533-.336c-.047.022-.221.12-.367.846-.194.966-.13,2.011.023,2.006C3963.47,676.326,3963.431,675.622,3963.934,674.622Z",
    transform: "translate(-3944.042 -658.359)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M3969.792,620.305c-.029-.166-.15-.848-.265-.82-.094.023-.162.517-.158.915.009.842.345,1.6.473,1.541S3969.9,620.922,3969.792,620.305Z",
    transform: "translate(-3949.563 -610.064)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M3993.88,635.474c-.005-.289-.014-.8-.119-.8s-.316.553-.371,1.079c-.076.735.135,1.456.271,1.426C3993.816,637.141,3993.893,636.126,3993.88,635.474Z",
    transform: "translate(-3971.045 -623.654)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M3987.936,552.456c.055-.454.13-1.084.008-1.117-.106-.029-.343.4-.468.789-.3.946-.058,1.989.1,1.968S3987.874,552.97,3987.936,552.456Z",
    transform: "translate(-3965.637 -549.08)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M4011.935,582.362c.049-.437.055-1.02-.044-1.03s-.31.644-.415,1.121c-.156.712-.219,1.6-.1,1.621A3.28,3.28,0,0,0,4011.935,582.362Z",
    transform: "translate(-3987.101 -575.922)",
    fill: "#dbf279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M4017.345,654.1c-.059-.272-.22-.867-.337-.828s-.18.6-.073,1.064c.1.438.363.809.461.748S4017.41,654.4,4017.345,654.1Z",
    transform: "translate(-3992.083 -640.303)",
    fill: "#dbf279"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(118.32 98.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M3939.957,1601.221a15.887,15.887,0,0,0-5.224-.886c-1.78-.052-2.514.179-4.8.02-1.141-.079-1.792-.195-2.832-.341-3.707-.522-5.708-.8-7.52-.65a12.992,12.992,0,0,0-6.922,2.927,15.086,15.086,0,0,0-4.935,8.337c-1.037,4.043-.376,7.308.371,11a38.118,38.118,0,0,0,4.191,10.941,15.515,15.515,0,0,0,4.709,5.858c.947.644,2.191,1.49,3.581,1.26a7.615,7.615,0,0,1,1.861-.365,4.952,4.952,0,0,1,2.172.646,9.995,9.995,0,0,0,8.414-.644c.547-.274.953.1,1.416.17,1.7.261,3.2-.872,4.172-1.6,5.261-3.954,8.077-13.753,8.077-13.753a21.411,21.411,0,0,0,1.68-9.584c-.149-2.549-.391-6.7-3.442-10.021A13.07,13.07,0,0,0,3939.957,1601.221Z",
    transform: "translate(-3907.187 -1582.866)",
    fill: "#ff6c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M4068.067,1617.163a17.941,17.941,0,0,0-5.671-.239c-.85.117-2.385.327-2.413.786-.035.574,2.305,1.2,2.816,1.339a13.766,13.766,0,0,0,4.9.429c1.659-.17,4.09-.726,4.058-1.272C4071.736,1617.78,4070.226,1617.526,4068.067,1617.163Z",
    transform: "translate(-4043.923 -1598.505)",
    fill: "#f95428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M3957.265,1442.861a1.045,1.045,0,0,0-.833.787c-.311,1.28-.683,4.524,1.378,9.85a14.726,14.726,0,0,0,7.919,7.547c1.543.613,2.528,1,3.736.675a4.575,4.575,0,0,0,2.768-2.51,5.511,5.511,0,0,0,.333-2.649,13.448,13.448,0,0,0-1.467-6.165,13.935,13.935,0,0,0-5.157-5.1C3961.768,1442.487,3958.567,1442.629,3957.265,1442.861Z",
    transform: "translate(-3951.038 -1442.748)",
    fill: "#adc936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M3995.734,1609.821a15.9,15.9,0,0,0-5.224-.886l-.14,0a11.949,11.949,0,0,1,5.034,4.173c4.781,7.194.071,19.057-5.8,24.8-4.961,4.854-12.264,6.81-20.094,5.746a12.546,12.546,0,0,0,3.256,3.382c.948.644,2.191,1.49,3.581,1.26a7.611,7.611,0,0,1,1.861-.365,4.949,4.949,0,0,1,2.172.646,9.994,9.994,0,0,0,8.414-.645c.547-.274.953.1,1.416.171,1.7.26,3.2-.872,4.172-1.6,5.261-3.954,8.076-13.753,8.076-13.753a21.41,21.41,0,0,0,1.68-9.584c-.149-2.549-.391-6.7-3.442-10.021A13.074,13.074,0,0,0,3995.734,1609.821Z",
    transform: "translate(-3962.963 -1591.466)",
    fill: "#f95428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M3969.123,1638.847a3.641,3.641,0,0,0-1.938.888,5.47,5.47,0,0,0-2.593,3.976,4.849,4.849,0,0,0,2.7,4.663c2.473,1.04,5.36-.891,6.092-3.287a5.212,5.212,0,0,0-.607-4.05C3972.7,1640.926,3971.217,1638.682,3969.123,1638.847Z",
    transform: "translate(-3958.552 -1618.229)",
    fill: "#ffa75f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M4067.014,1501.28a1.978,1.978,0,0,0,.074-.534A2.152,2.152,0,0,0,4067.014,1501.28Z",
    transform: "translate(-4050.216 -1494.651)",
    fill: "#abdd0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M4029.846,1465.893s.009.128.035.35C4029.865,1466.026,4029.85,1465.893,4029.846,1465.893Z",
    transform: "translate(-4016.954 -1463.46)",
    fill: "#abdd0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M4003.963,1465.9c-.568.046-1.251-1.389-1.281-1.774a39.958,39.958,0,0,1,.026-5.732,18.117,18.117,0,0,1-1.311,4.18c-.279.479-1.222-1.019-1.393-1.612a49.415,49.415,0,0,1-1.167-6.415c.077,1.005.2,3.858-.542,4.068-.588.168-1.588-1.387-2.038-2.25a13.049,13.049,0,0,1-1.09-3.542c-.075.007.219,1.517.126,2.391-.265,2.486,5.135,6.615,9.948,13.242,1.116,1.537.533-7.031.1-7.048C4004.966,1461.393,4004.937,1465.819,4003.963,1465.9Z",
    transform: "translate(-3985.909 -1451.763)",
    fill: "#c8d641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M3997.992,1561.049a1.9,1.9,0,0,0,.531.009A2.093,2.093,0,0,0,3997.992,1561.049Z",
    transform: "translate(-3988.448 -1548.606)",
    fill: "#94c106"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M3965.53,1480.287a6.649,6.649,0,0,0-2.963-.117,12.671,12.671,0,0,1,3.282,1.643c.771.585,2.13,1.828,1.875,2.391-.32.705-3.081.143-4.049-.091a47.745,47.745,0,0,1,6.07,2.168c.551.264,1.864,1.442,1.354,1.646a17.47,17.47,0,0,1-4.278.661,38.392,38.392,0,0,1,5.591.867c.37.09,1.663,1,1.529,1.559-.229.963-4.548.3-4.593.683-.051.433,7.522,2.657,6.411,1.116C3971.988,1487.58,3967.061,1481.036,3965.53,1480.287Z",
    transform: "translate(-3956.747 -1476.134)",
    fill: "#96ba25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M3970.256,1517.892c-.212-.061-.335-.093-.335-.09S3970.047,1517.841,3970.256,1517.892Z",
    transform: "translate(-3963.327 -1509.914)",
    fill: "#94c106"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(6.274 0.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M3972.075,1457.422c-1.571-1.856-3.185-3.729-4.8-5.568a.224.224,0,0,0-.322-.021.237.237,0,0,0-.013.329c1.612,1.837,3.224,3.708,4.793,5.562,2.857,3.375,4.43,5.235,6.086,7.527,1.391,1.926,2.7,3.939,3.9,5.987a.226.226,0,0,0,.311.086h0a.235.235,0,0,0,.076-.32c-1.207-2.06-2.528-4.086-3.927-6.025C3976.517,1462.672,3974.939,1460.807,3972.075,1457.422Z",
    transform: "translate(-3966.881 -1451.775)",
    fill: "#8ab20d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M4110.931,1542.892a.774.774,0,0,0-.839.158c-.377.429-.927,3.136-1.365,5.739a32.243,32.243,0,0,0-.421,3.939.439.439,0,0,0,.4.466.408.408,0,0,0,.417-.382,33.807,33.807,0,0,1,.772-4.515,13.079,13.079,0,0,1,1.263-3.927c.114-.169.538-.768.345-1.145A.814.814,0,0,0,4110.931,1542.892Z",
    transform: "translate(-4087.168 -1532.312)",
    fill: "#963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M4110.831,1545.181a13.092,13.092,0,0,0-1.263,3.927,33.973,33.973,0,0,0-.772,4.515.408.408,0,0,1-.417.382.386.386,0,0,1-.073-.011s0,0,0,.007a.439.439,0,0,0,.4.465.408.408,0,0,0,.417-.382,33.805,33.805,0,0,1,.772-4.515,13.079,13.079,0,0,1,1.263-3.927c.114-.168.538-.768.345-1.145a.565.565,0,0,0-.283-.245A1.942,1.942,0,0,1,4110.831,1545.181Z",
    transform: "translate(-4087.168 -1533.584)",
    fill: "#935d2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(0 87.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M3277.9,1357.651a28.534,28.534,0,0,0-8.6-9.116,34.426,34.426,0,0,0-11.511-4.894c-12.127-2.838-28.112-.8-47.509,6.054a232.005,232.005,0,0,0-29.875,13.155c-.258.135-.458.239-.595.309-15.583,7.976-29.623,13.283-41.729,15.774-9.263,1.906-17.358,2.414-23.775.975-7.782-1.745-13.934-3.817-15.16-7.6a18.167,18.167,0,0,1-.908-6.879c.269-2.106,1.377-.275,3.311-2.607-.7-6.043-1.3-13.085-1.917-17.941a54.278,54.278,0,0,0-7.28,9.23c-2.858,4.733-3.458,17.385-1.88,24.047.677,2.856,7.846,9.617,20.223,12.984,8.668,2.358,19.187,1.759,30.853-.641,13.554-2.788,28.971-8.576,45.823-17.2.163-.083.4-.207.705-.367a216.465,216.465,0,0,1,27.847-12.274c16.071-5.679,29.2-7.6,37.959-5.547,5.056,1.183,15.279,5.719,16.8,10.081,2.333,6.7-2.85,5.368-3.883,7.311-1.369,2.574-6.262,1.7-11.145,4.217a52.661,52.661,0,0,1-9.27,3.747,7.5,7.5,0,0,1,1.738-.163l-.259,11.917c1.064.016,2.24-.072,5.859-1.316a74.054,74.054,0,0,0,7.016-2.834,46.637,46.637,0,0,0,7.41-4.053c3.181-2.168,3.9-3.079,5.414-5.659C3277.977,1370.853,3279.885,1360.986,3277.9,1357.651Z",
    transform: "translate(-3089.623 -1342.401)",
    fill: "#ffda3e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M4301.17,1476.162a22.628,22.628,0,0,0-11.025-8.673c-.731-.287-1.447-.526-2.142-.726,3.611,1.3,15.074,6.987,11.7,11.9-1.59,2.32-7.313,6.83-11.36,9.346-3.78,2.35-10.837,4.46-10.837,4.46a29.728,29.728,0,0,1-2.123,15.406c.882.016,17.7-5.609,25.3-14.23a14.047,14.047,0,0,0,3.479-9.4A17.162,17.162,0,0,0,4301.17,1476.162Z",
    transform: "translate(-4118.369 -1453.693)",
    fill: "#ffc431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M4391.157,1476.162a22.626,22.626,0,0,0-11.025-8.673c-.731-.287-1.447-.526-2.142-.726,3.611,1.3,15.074,6.987,11.7,11.9a26.528,26.528,0,0,1-4.529,4.412,37.946,37.946,0,0,1-.914,4.709,39.854,39.854,0,0,1-8.31,15.733c5.127-2.3,11-5.643,14.731-9.872a14.049,14.049,0,0,0,3.479-9.4A17.151,17.151,0,0,0,4391.157,1476.162Z",
    transform: "translate(-4208.355 -1453.693)",
    fill: "#f9b723"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M4383.72,1476.162a22.626,22.626,0,0,0-11.025-8.673c-.731-.287-1.447-.526-2.142-.726,2.911,1.051,10.92,4.946,12.156,8.991a11.814,11.814,0,0,1,1.188,2.954c1.494,5.968-2.3,11.239-5.075,15.086a36.713,36.713,0,0,1-11.191,10.111c5.32-2.31,11.665-5.787,15.6-10.258a14.047,14.047,0,0,0,3.479-9.4A17.156,17.156,0,0,0,4383.72,1476.162Z",
    transform: "translate(-4200.918 -1453.693)",
    fill: "#f7a116"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(0.833 0.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(9.627 34.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M3190.847,1675.158h0a.3.3,0,0,0-.368.206l-1.324,4.708a.3.3,0,0,0,.206.367h0a.3.3,0,0,0,.367-.206l1.324-4.708A.3.3,0,0,0,3190.847,1675.158Z",
    transform: "translate(-3189.144 -1675.146)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(0.747 26.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M3106.353,1606.314a.3.3,0,0,0-.367.206l-1.324,4.708a.3.3,0,0,0,.206.367h0a.3.3,0,0,0,.368-.206l1.324-4.708A.3.3,0,0,0,3106.353,1606.314Z",
    transform: "translate(-3104.65 -1606.303)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(20.17 37.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M3291.165,1709.564h0a.3.3,0,0,0-.368.206l-1.324,4.708a.3.3,0,0,0,.206.367h0a.3.3,0,0,0,.367-.206l1.324-4.708A.3.3,0,0,0,3291.165,1709.564Z",
    transform: "translate(-3289.462 -1709.553)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    transform: "translate(39.075 38.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M3405.385,1712.94a.3.3,0,0,0-.324-.269h0a.3.3,0,0,0-.27.324l.451,4.87a.3.3,0,0,0,.324.269h0a.3.3,0,0,0,.269-.324Z",
    transform: "translate(-3404.79 -1712.67)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(51.588 35.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M3503.516,1692.027a.3.3,0,0,0-.353-.23h0a.3.3,0,0,0-.231.353l1,4.787a.3.3,0,0,0,.353.231h0a.3.3,0,0,0,.231-.353Z",
    transform: "translate(-3502.926 -1691.79)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(63.879 32.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M3599.641,1656.835a.3.3,0,0,0-.386-.17h0a.3.3,0,0,0-.17.386l1.773,4.558a.3.3,0,0,0,.386.17h0a.3.3,0,0,0,.169-.386Z",
    transform: "translate(-3599.065 -1656.645)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(75.77 27.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M3692.691,1615.875a.3.3,0,0,0-.4-.131h0a.3.3,0,0,0-.132.4l2.207,4.364a.3.3,0,1,0,.532-.269Z",
    transform: "translate(-3692.128 -1615.711)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(86.665 22.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M3778.184,1564.881a.3.3,0,1,0-.532.269l2.207,4.364a.3.3,0,0,0,.532-.269Z",
    transform: "translate(-3777.62 -1564.717)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(97.592 17.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M3866.184,1517.589l-2.745-4.047a.3.3,0,0,0-.493.334l2.745,4.047a.3.3,0,0,0,.493-.334Z",
    transform: "translate(-3862.894 -1513.411)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(109.622 11.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M3957.946,1460.592a.3.3,0,0,0-.41-.1h0a.3.3,0,0,0-.1.41l2.583,4.153a.3.3,0,0,0,.506-.315Z",
    transform: "translate(-3957.395 -1460.452)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(121.511 6.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M4051.63,1416.951a.3.3,0,0,0-.4-.131h0a.3.3,0,0,0-.132.4l2.207,4.364a.3.3,0,0,0,.4.131h0a.3.3,0,0,0,.132-.4Z",
    transform: "translate(-4051.066 -1416.787)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(133.683 3.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M4147.7,1380.8a.3.3,0,0,0-.386-.171h0a.3.3,0,0,0-.171.385l1.754,4.565a.3.3,0,0,0,.385.171h0a.3.3,0,0,0,.171-.385Z",
    transform: "translate(-4147.121 -1380.609)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(146.519 1.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M4249.872,1361.37a.3.3,0,0,0-.337-.252h0a.3.3,0,0,0-.252.337l.7,4.84a.3.3,0,0,0,.337.252h0a.3.3,0,0,0,.252-.338Z",
    transform: "translate(-4249.279 -1361.115)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(163.89 0.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M4349.661,1352.47a.3.3,0,1,0-.594-.044l-.366,4.877a.3.3,0,0,0,.595.044Z",
    transform: "translate(-4348.7 -1352.15)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(173.258 2.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M4439.746,1377.13h0a.3.3,0,0,0-.375.19l-1.526,4.647a.3.3,0,0,0,.19.376h0a.3.3,0,0,0,.376-.19l1.525-4.647A.3.3,0,0,0,4439.746,1377.13Z",
    transform: "translate(-4437.83 -1377.115)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(181.136 8.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M4514.7,1435.7h0a.3.3,0,0,0-.376.19l-1.526,4.646a.3.3,0,0,0,.19.376h0a.3.3,0,0,0,.376-.19l1.525-4.646A.3.3,0,0,0,4514.7,1435.7Z",
    transform: "translate(-4512.788 -1435.684)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(12.269 35.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M3215.352,1690.626h0a.3.3,0,0,0-.376.19l-.684,2.083a.3.3,0,0,0,.19.376h0a.3.3,0,0,0,.376-.19l.684-2.083A.3.3,0,0,0,3215.352,1690.626Z",
    transform: "translate(-3214.278 -1690.611)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(8.334 33.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M3177.921,1669.2h0a.3.3,0,0,0-.376.19l-.684,2.082a.3.3,0,0,0,.19.376h0a.3.3,0,0,0,.376-.19l.684-2.082A.3.3,0,0,0,3177.921,1669.2Z",
    transform: "translate(-3176.846 -1669.186)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(6.679 32.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M3162.17,1658.63h0a.3.3,0,0,0-.376.19l-.684,2.083a.3.3,0,0,0,.19.376h0a.3.3,0,0,0,.376-.19l.684-2.082A.3.3,0,0,0,3162.17,1658.63Z",
    transform: "translate(-3161.096 -1658.615)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(4.709 30.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M3143.425,1643.919a.3.3,0,0,0-.376.19l-.684,2.083a.3.3,0,1,0,.566.186l.684-2.083A.3.3,0,0,0,3143.425,1643.919Z",
    transform: "translate(-3142.351 -1643.904)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(2.928 29.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M3126.479,1628.281a.3.3,0,0,0-.376.19l-.684,2.082a.3.3,0,1,0,.566.186l.684-2.082A.3.3,0,0,0,3126.479,1628.281Z",
    transform: "translate(-3125.404 -1628.266)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(0 25.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M3098.621,1591.342h0a.3.3,0,0,0-.376.19l-.684,2.082a.3.3,0,0,0,.19.376h0a.3.3,0,0,0,.376-.19l.684-2.082A.3.3,0,0,0,3098.621,1591.342Z",
    transform: "translate(-3097.547 -1591.327)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(14.06 36.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M3232.4,1698.655h0a.3.3,0,0,0-.376.19l-.684,2.083a.3.3,0,0,0,.19.376h0a.3.3,0,0,0,.376-.19l.684-2.083A.3.3,0,0,0,3232.4,1698.655Z",
    transform: "translate(-3231.321 -1698.64)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(16.296 37.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M3253.669,1704.636h0a.3.3,0,0,0-.376.19l-.683,2.083a.3.3,0,0,0,.19.376h0a.3.3,0,0,0,.376-.19l.683-2.083A.3.3,0,0,0,3253.669,1704.636Z",
    transform: "translate(-3252.595 -1704.621)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(18.379 37.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M3273.49,1709.711h0a.3.3,0,0,0-.376.19l-.683,2.083a.3.3,0,0,0,.19.376h0a.3.3,0,0,0,.376-.19l.684-2.083A.3.3,0,0,0,3273.49,1709.711Z",
    transform: "translate(-3272.416 -1709.697)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(23.091 38.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M3318.258,1714.89a.3.3,0,1,0-.585-.114l-.419,2.151a.3.3,0,1,0,.585.114Z",
    transform: "translate(-3317.248 -1714.535)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(25.272 38.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M3338.792,1716.974a.3.3,0,0,0-.27-.324h0a.3.3,0,0,0-.323.27l-.2,2.183a.3.3,0,0,0,.27.324h0a.3.3,0,0,0,.324-.27Z",
    transform: "translate(-3337.998 -1716.649)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(27.697 38.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M3361.674,1718.92a.3.3,0,0,0-.3-.3h0a.3.3,0,0,0-.3.3v2.192a.3.3,0,0,0,.3.3h0a.3.3,0,0,0,.3-.3Z",
    transform: "translate(-3361.078 -1718.622)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    transform: "translate(29.839 38.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M3382.053,1716.038a.3.3,0,0,0-.324-.269h0a.3.3,0,0,0-.269.324l.2,2.182a.3.3,0,0,0,.324.269h0a.3.3,0,0,0,.269-.324Z",
    transform: "translate(-3381.459 -1715.768)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(41.638 37.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M3425.567,1712.019a.3.3,0,1,0-.588.1l.363,2.162a.3.3,0,0,0,.343.245h0a.3.3,0,0,0,.245-.343Z",
    transform: "translate(-3424.975 -1711.771)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609",
    transform: "translate(44.137 37.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M3445.215,1707.021a.3.3,0,0,0-.343-.244h0a.3.3,0,0,0-.244.343l.363,2.162a.3.3,0,0,0,.343.244h0a.3.3,0,0,0,.244-.343Z",
    transform: "translate(-3444.624 -1706.772)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(46.673 37.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M3465.155,1703.672a.3.3,0,0,0-.343-.245h0a.3.3,0,0,0-.244.343l.363,2.162a.3.3,0,0,0,.343.245h0a.3.3,0,0,0,.245-.343Z",
    transform: "translate(-3464.563 -1703.423)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    transform: "translate(49.04 36.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M3483.772,1697.047a.3.3,0,0,0-.343-.245h0a.3.3,0,0,0-.244.343l.363,2.161a.3.3,0,0,0,.343.244h0a.3.3,0,0,0,.244-.343Z",
    transform: "translate(-3483.18 -1696.798)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(54.078 35.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M3523.252,1687.919a.3.3,0,0,0-.372-.2h0a.3.3,0,0,0-.2.371l.635,2.1a.3.3,0,0,0,.371.2h0a.3.3,0,0,0,.2-.371Z",
    transform: "translate(-3522.668 -1687.707)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(56.557 34.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M3542.74,1681.93a.3.3,0,0,0-.372-.2h0a.3.3,0,0,0-.2.372l.635,2.1a.3.3,0,0,0,.372.2h0a.3.3,0,0,0,.2-.372Z",
    transform: "translate(-3542.156 -1681.719)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    transform: "translate(58.953 34.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M3561.576,1675.06a.3.3,0,0,0-.371-.2h0a.3.3,0,0,0-.2.372l.635,2.1a.3.3,0,0,0,.371.2h0a.3.3,0,0,0,.2-.371Z",
    transform: "translate(-3560.993 -1674.848)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(61.397 33.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M3580.692,1667.629a.3.3,0,0,0-.386-.17h0a.3.3,0,0,0-.169.386l.794,2.043a.3.3,0,0,0,.386.17h0a.3.3,0,0,0,.17-.386Z",
    transform: "translate(-3580.117 -1667.439)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(66.286 31.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M3618.99,1648.577a.3.3,0,0,0-.4-.131h0a.3.3,0,0,0-.132.4l.99,1.956a.3.3,0,1,0,.531-.269Z",
    transform: "translate(-3618.426 -1648.414)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(68.97 30.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M3640.08,1640.715a.3.3,0,0,0-.532.269l.989,1.956a.3.3,0,0,0,.532-.269Z",
    transform: "translate(-3639.516 -1640.551)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(71.167 29.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M3657.347,1631.942a.3.3,0,1,0-.532.269l.989,1.956a.3.3,0,0,0,.532-.269Z",
    transform: "translate(-3656.783 -1631.779)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(73.27 28.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M3673.873,1623.585a.3.3,0,1,0-.532.269l.989,1.956a.3.3,0,1,0,.532-.269Z",
    transform: "translate(-3673.309 -1623.422)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(77.755 26.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M3709.119,1605.76a.3.3,0,1,0-.532.269l.989,1.956a.3.3,0,1,0,.532-.269Z",
    transform: "translate(-3708.555 -1605.597)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(79.854 25.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M3725.613,1597.458a.3.3,0,0,0-.532.269l.989,1.956a.3.3,0,1,0,.532-.269Z",
    transform: "translate(-3725.049 -1597.295)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(81.895 25.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M3741.651,1589.308a.3.3,0,1,0-.532.269l.989,1.956a.3.3,0,1,0,.531-.269Z",
    transform: "translate(-3741.087 -1589.145)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(83.991 23.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M3758.117,1578.218a.3.3,0,1,0-.532.269l.989,1.956a.3.3,0,0,0,.532-.269Z",
    transform: "translate(-3757.553 -1578.054)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(89.088 21.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M3799.193,1559.284l-1.23-1.814a.3.3,0,1,0-.493.334l1.23,1.814a.3.3,0,0,0,.414.079h0A.3.3,0,0,0,3799.193,1559.284Z",
    transform: "translate(-3797.418 -1557.34)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(90.974 20.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M3814.007,1550.276l-1.23-1.814a.3.3,0,0,0-.414-.079h0a.3.3,0,0,0-.079.414l1.23,1.814a.3.3,0,0,0,.493-.334Z",
    transform: "translate(-3812.232 -1548.332)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(93.22 19.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M3831.655,1541.234l-1.23-1.814a.3.3,0,0,0-.414-.079h0a.3.3,0,0,0-.079.414l1.23,1.814a.3.3,0,0,0,.493-.334Z",
    transform: "translate(-3829.88 -1539.289)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(95.273 18.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M3847.78,1530.3l-1.23-1.814a.3.3,0,1,0-.493.334l1.23,1.814a.3.3,0,0,0,.493-.335Z",
    transform: "translate(-3846.005 -1528.351)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(99.946 16.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M3884.49,1505.393l-1.23-1.814a.3.3,0,0,0-.414-.079h0a.3.3,0,0,0-.079.414l1.23,1.814a.3.3,0,0,0,.493-.335Z",
    transform: "translate(-3882.715 -1503.449)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629",
    transform: "translate(102.153 14.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M3901.828,1493.633l-1.23-1.814a.3.3,0,1,0-.493.334l1.23,1.814a.3.3,0,1,0,.493-.334Z",
    transform: "translate(-3900.053 -1491.688)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(104.879 13.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M3923.24,1483.434l-1.231-1.814a.3.3,0,0,0-.414-.079h0a.3.3,0,0,0-.079.414l1.23,1.814a.3.3,0,0,0,.414.079h0A.3.3,0,0,0,3923.24,1483.434Z",
    transform: "translate(-3921.465 -1481.489)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(107.358 12.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M3941.562,1471.718a.3.3,0,0,0-.41-.1h0a.3.3,0,0,0-.1.411l1.158,1.861a.3.3,0,0,0,.41.1h0a.3.3,0,0,0,.1-.41Z",
    transform: "translate(-3941.011 -1471.577)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(111.805 10.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M3976.5,1452.384a.3.3,0,1,0-.506.315l1.157,1.861a.3.3,0,0,0,.506-.315Z",
    transform: "translate(-3975.949 -1452.244)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(114.278 9.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M3995.933,1443.295a.3.3,0,0,0-.411-.1h0a.3.3,0,0,0-.1.41l1.158,1.861a.3.3,0,0,0,.41.1h0a.3.3,0,0,0,.1-.41Z",
    transform: "translate(-3995.381 -1443.154)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(116.577 8.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M4014,1433.345a.3.3,0,0,0-.411-.1h0a.3.3,0,0,0-.1.41l1.158,1.861a.3.3,0,0,0,.411.1h0a.3.3,0,0,0,.1-.41Z",
    transform: "translate(-4013.446 -1433.205)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(118.981 7.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M4033.076,1425.632a.3.3,0,0,0-.4-.132h0a.3.3,0,0,0-.131.4l.989,1.956a.3.3,0,0,0,.4.131h0a.3.3,0,0,0,.131-.4Z",
    transform: "translate(-4032.511 -1425.469)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(123.765 6.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M4070.665,1411.013a.3.3,0,0,0-.4-.131h0a.3.3,0,0,0-.131.4l.989,1.956a.3.3,0,0,0,.4.131h0a.3.3,0,0,0,.131-.4Z",
    transform: "translate(-4070.101 -1410.85)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(126.254 5.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M4090.226,1402.8a.3.3,0,0,0-.4-.131h0a.3.3,0,0,0-.131.4l.989,1.956a.3.3,0,0,0,.4.131h0a.3.3,0,0,0,.131-.4Z",
    transform: "translate(-4089.662 -1402.634)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(128.823 4.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M4110.52,1394.926a.3.3,0,0,0-.395-.149h0a.3.3,0,0,0-.149.394l.9,2a.3.3,0,0,0,.394.149h0a.3.3,0,0,0,.149-.394Z",
    transform: "translate(-4109.95 -1394.75)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(131.173 3.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M4128.988,1386.934a.3.3,0,0,0-.395-.149h0a.3.3,0,0,0-.148.394l.9,2a.3.3,0,0,0,.394.149h0a.3.3,0,0,0,.149-.394Z",
    transform: "translate(-4128.418 -1386.759)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(136.087 2.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M4167.881,1375.393a.3.3,0,0,0-.376-.19h0a.3.3,0,0,0-.19.376l.683,2.083a.3.3,0,0,0,.376.19h0a.3.3,0,0,0,.19-.376Z",
    transform: "translate(-4167.3 -1375.188)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    transform: "translate(138.702 2.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M4188.438,1371.761a.3.3,0,0,0-.376-.19h0a.3.3,0,0,0-.19.376l.683,2.083a.3.3,0,0,0,.376.19h0a.3.3,0,0,0,.19-.376Z",
    transform: "translate(-4187.857 -1371.556)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(141.05 1.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M4207.071,1367.134a.3.3,0,0,0-.363-.214h0a.3.3,0,0,0-.214.363l.547,2.122a.3.3,0,0,0,.363.214h0a.3.3,0,0,0,.214-.363Z",
    transform: "translate(-4206.484 -1366.911)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(143.925 1.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M4229.976,1363.293a.3.3,0,0,0-.338-.252h0a.3.3,0,0,0-.252.338l.313,2.169a.3.3,0,0,0,.337.252h0a.3.3,0,0,0,.252-.337Z",
    transform: "translate(-4229.382 -1363.037)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(148.763 0.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M4268.024,1357.793a.3.3,0,0,0-.337-.252h0a.3.3,0,0,0-.252.338l.314,2.169a.3.3,0,0,0,.337.252h0a.3.3,0,0,0,.252-.337Z",
    transform: "translate(-4267.431 -1357.537)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    transform: "translate(157.654 0.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M4289.965,1354.746a.3.3,0,0,0-.3-.293h0a.3.3,0,0,0-.293.3l.036,2.192a.3.3,0,0,0,.3.293h0a.3.3,0,0,0,.293-.3Z",
    transform: "translate(-4289.369 -1354.453)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646",
    transform: "translate(159.795 0.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M4310.334,1352.51a.3.3,0,0,0-.3-.293h0a.3.3,0,0,0-.293.3l.036,2.192a.3.3,0,0,0,.3.293h0a.3.3,0,0,0,.293-.3Z",
    transform: "translate(-4309.738 -1352.217)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647",
    transform: "translate(162.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M4331.8,1351.192a.3.3,0,0,0-.3-.293h0a.3.3,0,0,0-.293.3l.036,2.191a.3.3,0,0,0,.3.293h0a.3.3,0,0,0,.293-.3Z",
    transform: "translate(-4331.202 -1350.899)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(166.13 0.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M4370.874,1355.359a.3.3,0,0,0-.258-.333h0a.3.3,0,0,0-.333.258l-.273,2.175a.3.3,0,0,0,.258.333h0a.3.3,0,0,0,.333-.258Z",
    transform: "translate(-4370.006 -1355.024)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649",
    transform: "translate(168.072 0.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M4389.436,1358.014a.3.3,0,1,0-.588-.1l-.354,2.163a.3.3,0,1,0,.588.1Z",
    transform: "translate(-4388.49 -1357.668)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(169.929 1.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M4407.149,1362.96h0a.3.3,0,0,0-.369.2l-.609,2.106a.3.3,0,0,0,.2.369h0a.3.3,0,0,0,.369-.2l.608-2.105A.3.3,0,0,0,4407.149,1362.96Z",
    transform: "translate(-4406.16 -1362.948)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(171.963 1.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M4426.5,1369.908h0a.3.3,0,0,0-.369.2l-.609,2.106a.3.3,0,0,0,.2.369h0a.3.3,0,0,0,.369-.2l.608-2.106A.3.3,0,0,0,4426.5,1369.908Z",
    transform: "translate(-4425.508 -1369.896)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(175.821 4.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M4463.383,1390.337h0a.3.3,0,0,0-.383.176l-.76,2.056a.3.3,0,0,0,.176.383h0a.3.3,0,0,0,.383-.176l.759-2.056A.3.3,0,0,0,4463.383,1390.337Z",
    transform: "translate(-4462.222 -1390.318)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(177.394 5.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M4478.346,1402.33h0a.3.3,0,0,0-.383.176l-.76,2.056a.3.3,0,0,0,.176.383h0a.3.3,0,0,0,.383-.176l.759-2.056A.3.3,0,0,0,4478.346,1402.33Z",
    transform: "translate(-4477.185 -1402.311)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(178.862 6.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M4492.312,1415.716h0a.3.3,0,0,0-.383.176l-.76,2.056a.3.3,0,0,0,.176.383h0a.3.3,0,0,0,.382-.176l.76-2.056A.3.3,0,0,0,4492.312,1415.716Z",
    transform: "translate(-4491.15 -1415.698)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(180.345 8.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M4506.427,1427.118h0a.3.3,0,0,0-.383.176l-.76,2.056a.3.3,0,0,0,.176.383h0a.3.3,0,0,0,.383-.176l.76-2.056A.3.3,0,0,0,4506.427,1427.118Z",
    transform: "translate(-4505.266 -1427.1)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(184.188 12.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M4542.991,1472.3h0a.3.3,0,0,0-.383.176l-.759,2.056a.3.3,0,0,0,.176.383h0a.3.3,0,0,0,.383-.176l.76-2.056A.3.3,0,0,0,4542.991,1472.3Z",
    transform: "translate(-4541.83 -1472.279)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(185.283 14.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M4553.4,1488.453h0a.3.3,0,0,0-.383.176l-.76,2.056a.3.3,0,0,0,.177.383h0a.3.3,0,0,0,.382-.176l.759-2.056A.3.3,0,0,0,4553.4,1488.453Z",
    transform: "translate(-4552.241 -1488.435)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(186.278 16.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M4562.877,1507.464h0a.3.3,0,0,0-.383.176l-.76,2.056a.3.3,0,0,0,.176.383h0a.3.3,0,0,0,.383-.176l.76-2.056A.3.3,0,0,0,4562.877,1507.464Z",
    transform: "translate(-4561.716 -1507.445)",
    fill: "#995e08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(183.115 10.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M4532.781,1454.389h0a.3.3,0,0,0-.383.176l-.759,2.056a.3.3,0,0,0,.176.383h0a.3.3,0,0,0,.383-.176l.76-2.056A.3.3,0,0,0,4532.781,1454.389Z",
    transform: "translate(-4531.62 -1454.371)",
    fill: "#995e08"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M3111.271,1397.052c-1.966-4.907-1.537-6.22,1.887-10.473-.317-2.059-1.516-13.021-2.057-18.009a57.527,57.527,0,0,0-5.934,6.861c-2.936,5.219-3.583,10.124-1.761,14.036,1.929,4.14,8.359,10.893,18.642,13.425a53.8,53.8,0,0,0,8.763,1.427C3121.706,1403.4,3112.135,1399.208,3111.271,1397.052Z",
    transform: "translate(-3101.047 -1366.148)",
    fill: "#ffc431"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan1);
export default __webpack_public_path__ + "static/media/plan1.9ba6add8c8d4a7d23b52b044b4d262d8.svg";
export { ForwardRef as ReactComponent };